<template>
  <div>
    <v-container fluid>
      <v-overlay v-model="showSuccess" :scrim="true" opacity="0.3" persistent :z-index="9998">
      </v-overlay>
      <transition name="fade-slide">
        <output v-if="showSuccess" class="success-toast">
          <img src="@/assets/mdi_success-bold.svg" alt="img" width="20" height="20" />
          <span style="font-size: 15px; font-weight: 600;">{{ successMessage }}</span>
        </output>
      </transition>
      <v-row>
        <v-col cols="12" sm="12" md="4" lg="4" v-if="showLeftPanel && !SetPopup">
          <v-card @click="showTimeDelay = !showTimeDelay" class="parameter-card">
            <v-card-title class="parameters-header">
              <div class="d-flex justify-start align-center mt-1" style="gap: 8px;">
                <img src="@/assets/ix_parameter.svg" alt="img" width="16" height="16" />
                <span style="color: #171717; font-weight: 600; font-size: 16px;">Parameters </span>
              </div>
              <div>
                <img v-if="!showTimeDelay" src="@/assets/arrow-drop-down.svg" alt="img" width="16" height="16" />
                <img v-else src="@/assets/arrow-up.svg" alt="img" width="16" height="16" />
              </div>
            </v-card-title>

            <div v-if="showTimeDelay" class="parameters-body">
              <v-col cols="12" sm="12" md="12">
                <span style="font-size:13px; color:#171717; font-weight:600;">{{ $t('timeDelayModelA') }}</span>
                <v-text-field class="modern-number-field" :placeholder="$t('timeDelayModelA')"
                  v-model="configLeft.typingSpeed" variant="none" density="compact" type="number" clearable min="0"
                  hide-details></v-text-field>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <span style="font-size:13px; color:#171717; font-weight:600;">{{ $t('timeDelayModelB') }}</span>
                <v-text-field clearable class="modern-number-field" :placeholder="$t('timeDelayModelB')"
                  v-model="configRight.typingSpeed" variant="none" density="compact" type="number" min="0"
                  hide-details></v-text-field>
              </v-col>
            </div>
          </v-card>

          <div class="mt-3">
            <hr>
          </div>

          <v-row class="mt-4" v-if="configLeft.model != '' && configLeft.model != null">
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-card class="parameter-card">
                <div class="log-modelA-header" @click="LOG_STATUS_LEFT = !LOG_STATUS_LEFT; LOG_STATUS_RIGHT = false;">
                  <div class="d-flex justify-start align-center" style="gap: 8px;">
                    <img src="@/assets/tabler_logs.svg" alt="img" width="16" height="16" />
                    <span style="font-weight: 600;">Log Model A</span>
                  </div>
                  <div class="d-flex align-center">
                    <img v-if="LOG_STATUS_LEFT == false" src="@/assets/arrow-drop-down.svg" alt="img" width="16"
                      height="16" />
                    <img v-else src="@/assets/arrow-up.svg" alt="img" width="16" height="16" />
                  </div>
                </div>

                <div v-if="LOG_STATUS_LEFT == true" class="parameters-body pa-3">
                  <v-row style="margin-top: -16px;">
                    <v-col>
                      <span style="font-size: 12px; color: #171717;">System Message</span>
                      <v-textarea class="model-input-control mt-2" variant="none" v-model="DataLogLeft.Prompt" rows="2">
                      </v-textarea>
                    </v-col>
                  </v-row>

                  <v-row style="margin-top: 0px;">
                    <v-col>
                      <span style="font-size: 12px;">Knowledge</span>
                      <v-textarea class="model-input-control mt-2" variant="none" v-model="DataLogLeft.Vector"
                        rows="2"></v-textarea>
                    </v-col>
                  </v-row>

                  <v-row style="margin-top: 0px;">
                    <v-col>
                      <span style="font-size: 12px;">SQL Query</span>
                      <v-textarea class="model-input-control mt-2" variant="none" v-model="DataLogLeft.ReplySQL"
                        rows="2"></v-textarea>
                    </v-col>
                  </v-row>

                  <v-row style="margin-top: 0px;">
                    <v-col style="margin-top: 0px;">
                      <span style="font-size: 12px;">SQL Query Result</span>
                      <v-textarea class="model-input-control mt-2" variant="none" v-model="DataLogLeft.ReplyDataSelect"
                        rows="2"></v-textarea>
                    </v-col>
                  </v-row>

                  <v-row style="margin-top: 0px;">
                    <v-col style="margin-top: 0px;">
                      <span style="font-size: 12px;">Intent Flow</span>
                      <v-textarea class="model-input-control mt-2" variant="none" v-model="DataLogLeft.FlowActionIntent"
                        rows="2"></v-textarea>
                    </v-col>
                  </v-row>

                  <v-row style="margin-top: 0px;">
                    <v-col style="margin-top: 0px;">
                      <span style="font-size: 12px;">Memory</span>
                      <v-textarea class="model-input-control mt-2" variant="none" v-model="DataLogLeft.Memory"
                        rows="2"></v-textarea>
                    </v-col>
                  </v-row>

                  <v-row style="margin-top: 0px;">
                    <v-col style="margin-top: 0px;">
                      <span style="font-size: 14px;font-weight: 600;">LLMs Model</span>
                    </v-col>
                  </v-row>
                  <div style="border: 1px solid #646464; border-radius: 6px; padding: 12px;">
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">ModelID : {{ DataLogLeft.GPT_Model.modelId }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">ModelName : {{ DataLogLeft.GPT_Model.modelName }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">Provider : {{ DataLogLeft.GPT_Model.Provider }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">Model : {{ DataLogLeft.GPT_Model.model }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">SystemMessage</span>
                        <v-textarea class="model-input-control mt-2" variant="none"
                          v-model="DataLogLeft.GPT_Model.promptTemplate" rows="2"></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">KnowledgeDocuments</span>
                        <v-textarea class="model-input-control mt-2" variant="none"
                          v-model="DataLogLeft.GPT_Model.vectordbName" rows="2"></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">Extension : {{ DataLogLeft.GPT_Model.extension }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">Description : {{ DataLogLeft.GPT_Model.description }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">Gender : {{ DataLogLeft.GPT_Model.gender }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">TopN_Chunks : {{ DataLogLeft.GPT_Model.topVDB }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">Internet : {{ DataLogLeft.GPT_Model.internet }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">Feedback : {{ DataLogLeft.GPT_Model.feedback }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">HistoryCount : {{ DataLogLeft.GPT_Model.historyCount }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">HistoryMinute : {{ DataLogLeft.GPT_Model.historyMinute }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">Temperature : {{ DataLogLeft.GPT_Model.temperature }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">Top_P : {{ DataLogLeft.GPT_Model.topP }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">Frequency_Penalty : {{ DataLogLeft.GPT_Model.frequency_penalty
                        }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">Presence_Penalty : {{ DataLogLeft.GPT_Model.presence_penalty
                        }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">Stop_Sequence : {{ DataLogLeft.GPT_Model.Stop }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">MaxTokensResponse : {{ DataLogLeft.GPT_Model.maxTokens }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">IsStream : {{ DataLogLeft.GPT_Model.isStream }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">Endpoint </span>
                        <v-textarea class="model-input-control mt-2" variant="none"
                          v-model="DataLogLeft.GPT_Model.EndpointURL" rows="2"></v-textarea>
                      </v-col>
                    </v-row>
                  </div>
                  <v-row style="margin-top: 0px;">
                    <v-col style="margin-top: 0px;">
                      <span style="font-size: 12px;">{{ $t('UserQuery') }} : {{ DataLogLeft.TextVector }}</span>
                    </v-col>
                  </v-row>
                  <v-row style="margin-top: 0px;">
                    <v-col style="margin-top: 0px;">
                      <span style="font-size: 12px;">{{ $t('OrgVectorSearch') }} : {{ DataLogLeft.Text }}</span>
                    </v-col>
                  </v-row>
                  <v-row style="margin-top: 0px;">
                    <v-col style="margin-top: 0px;">
                      <span style="font-size: 12px;">{{ $t('ModVectorSearch') }} : {{ DataLogLeft.Translate ?? "-"
                      }}</span>
                    </v-col>
                  </v-row>
                  <v-row style="margin-top: 0px;">
                    <v-col style="margin-top: 0px;">
                      <span style="font-size: 12px;">Vector Cosine</span>
                      <v-textarea class="model-input-control mt-2" variant="none" v-model="DataLogLeft.VectorCoise"
                        rows="2"></v-textarea>
                    </v-col>
                  </v-row>

                  <v-row style="margin-top: 0px;">
                    <v-col style="margin-top: 0px;">
                      <span style="font-size: 12px;">Private Memory</span>
                      <v-textarea class="model-input-control mt-2" variant="none" v-model="DataLogLeft.Private_Memory"
                        rows="2"></v-textarea>
                    </v-col>
                  </v-row>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row class="mt-4" v-if="configRight.model != '' && configRight.model != null">
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-card class="parameter-card">
                <div class="log-modelA-header" @click="LOG_STATUS_RIGHT = !LOG_STATUS_RIGHT; LOG_STATUS_LEFT = false;">
                  <div class="d-flex justify-start align-center" style="gap: 8px;">
                    <img src="@/assets/tabler_logs.svg" alt="img" width="16" height="16" />
                    <span style="font-weight: 600;">Log Model B</span>
                  </div>
                  <div class="d-flex align-center">
                    <img v-if="LOG_STATUS_RIGHT == false" src="@/assets/arrow-drop-down.svg" alt="img" width="16"
                      height="16" />
                    <img v-else src="@/assets/arrow-up.svg" alt="img" width="16" height="16" />
                  </div>
                </div>

                <div v-if="LOG_STATUS_RIGHT == true" class="parameters-body pa-3">
                  <v-row style="margin-top: 0px;">
                    <v-col style="margin-top: 0px;">
                      <span style="font-size: 12px;">System Message</span>
                      <v-textarea class="model-input-control mt-2" variant="none" v-model="DataLogRight.Prompt"
                        rows="2"></v-textarea>
                    </v-col>
                  </v-row>

                  <v-row style="margin-top: 0px;">
                    <v-col style="margin-top: 0px;">
                      <span style="font-size: 12px;">Knowledge</span>
                      <v-textarea class="model-input-control mt-2" variant="none" v-model="DataLogRight.Vector"
                        rows="2"></v-textarea>
                    </v-col>
                  </v-row>

                  <v-row style="margin-top: 0px;">
                    <v-col style="margin-top: 0px;">
                      <span style="font-size: 12px;">SQL Query</span>
                      <v-textarea class="model-input-control mt-2" variant="none" v-model="DataLogRight.ReplySQL"
                        rows="2"></v-textarea>
                    </v-col>
                  </v-row>

                  <v-row style="margin-top: 0px;">
                    <v-col style="margin-top: 0px;">
                      <span style="font-size: 12px;">SQL Query Result</span>
                      <v-textarea class="model-input-control mt-2" variant="none" v-model="DataLogRight.ReplyDataSelect"
                        rows="2"></v-textarea>
                    </v-col>
                  </v-row>

                  <v-row style="margin-top: 0px;">
                    <v-col style="margin-top: 0px;">
                      <span style="font-size: 12px;">Intent Flow</span>
                      <v-textarea class="model-input-control mt-2" variant="none"
                        v-model="DataLogRight.FlowActionIntent" rows="2"></v-textarea>
                    </v-col>
                  </v-row>

                  <v-row style="margin-top: 0px;">
                    <v-col style="margin-top: 0px;">
                      <span style="font-size: 12px;">Memory</span>
                      <v-textarea class="model-input-control mt-2" variant="none" v-model="DataLogRight.Memory"
                        rows="2"></v-textarea>
                    </v-col>
                  </v-row>

                  <v-row style="margin-top: 0px;">
                    <v-col style="margin-top: 0px;">
                      <span style="font-size: 12px;font-weight: 600;">LLMs Model</span>
                    </v-col>
                  </v-row>
                  <div style="border: 1px solid #646464; border-radius: 5px; padding: 12px;">
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">ModelID : {{ DataLogRight.GPT_Model.modelId }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">ModelName : {{ DataLogRight.GPT_Model.modelName }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">Provider : {{ DataLogRight.GPT_Model.Provider }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">Model : {{ DataLogRight.GPT_Model.model }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">SystemMessage</span>
                        <v-textarea class="model-input-control mt-2" variant="none"
                          v-model="DataLogRight.GPT_Model.promptTemplate" rows="2"></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">KnowledgeDocuments</span>
                        <v-textarea class="model-input-control mt-2" variant="none"
                          v-model="DataLogRight.GPT_Model.vectordbName" rows="2"></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">Extension : {{ DataLogRight.GPT_Model.extension }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">Description : {{ DataLogRight.GPT_Model.description }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">Gender : {{ DataLogRight.GPT_Model.gender }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">TopN_Chunks : {{ DataLogRight.GPT_Model.topVDB }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">Internet : {{ DataLogRight.GPT_Model.internet }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">Feedback : {{ DataLogRight.GPT_Model.feedback }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">HistoryCount : {{ DataLogRight.GPT_Model.historyCount }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">HistoryMinute : {{ DataLogRight.GPT_Model.historyMinute }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">Temperature : {{ DataLogRight.GPT_Model.temperature }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">Top_P : {{ DataLogRight.GPT_Model.topP }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">Frequency_Penalty : {{ DataLogRight.GPT_Model.frequency_penalty
                        }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">Presence_Penalty : {{ DataLogRight.GPT_Model.presence_penalty
                        }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">Stop_Sequence : {{ DataLogRight.GPT_Model.Stop }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">MaxTokensResponse : {{ DataLogRight.GPT_Model.maxTokens }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">IsStream : {{ DataLogRight.GPT_Model.isStream }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: 0px;">
                      <v-col style="margin-top: 0px;">
                        <span style="font-size: 12px;">Endpoint </span>
                        <v-textarea class="model-input-control mt-2" variant="none"
                          v-model="DataLogRight.GPT_Model.EndpointURL" rows="2"></v-textarea>
                      </v-col>
                    </v-row>
                  </div>
                  <v-row style="margin-top: 0px;">
                    <v-col style="margin-top: 0px;">
                      <span style="font-size: 12px;">{{ $t('UserQuery') }} : {{ DataLogRight.TextVector }}</span>
                    </v-col>
                  </v-row>
                  <v-row style="margin-top: 0px;">
                    <v-col style="margin-top: 0px;">
                      <span style="font-size: 12px;">{{ $t('OrgVectorSearch') }} : {{ DataLogRight.Text }}</span>
                    </v-col>
                  </v-row>
                  <v-row style="margin-top: 0px;">
                    <v-col style="margin-top: 0px;">
                      <span style="font-size: 12px;">{{ $t('ModVectorSearch') }} : {{ DataLogRight.Translate ?? "-"
                      }}</span>
                    </v-col>
                  </v-row>
                  <v-row style="margin-top: 0px;">
                    <v-col style="margin-top: 0px;">
                      <span style="font-size: 12px;">Vector Cosine</span>
                      <v-textarea class="model-input-control mt-2" variant="none" v-model="DataLogRight.VectorCoise"
                        rows="2"></v-textarea>
                    </v-col>
                  </v-row>

                  <v-row style="margin-top: 0px;">
                    <v-col style="margin-top: 0px;">
                      <span style="font-size: 12px;">Private Memory</span>
                      <v-textarea class="model-input-control mt-2" variant="none" v-model="DataLogRight.Private_Memory"
                        rows="2"></v-textarea>
                    </v-col>
                  </v-row>
                </div>

                <div v-if="Topic_STATUS == true" style="    padding: 0px; ">
                  <v-row id="toppic_list_id"
                    style="margin-top: 0px;    overflow-x: hidden;    overflow-y: auto;    height: calc(100vh - 330px); min-height: 29vh;display: block;">
                    <v-col class="col-12" v-for="(iTopic, indexTopic) in listTopic" :key="iTopic.topicID"
                      style="    padding-top: 0px; padding-bottom: 5px; ">
                      <v-card v-show="iTopic.status == true" style="cursor:pointer;">
                        <v-card-title class="  white--text" style="    padding: 5px;padding-left: 10px; "
                          :style="'background-color:' + (Log_History_TopicID == iTopic.topicID ? '#004e8c' : '#ff4646')">
                          <span style="width: 88%;">
                            <v-text-field class="Cls_Text_field_TopicName " :id="'TopicId_' + iTopic.topicID" outlined
                              dense v-model="iTopic.topicName"
                              v-on:blur="iTopic.status = false; RenameTopicStream(iTopic.topicID, iTopic.keyTopic, iTopic.topicName, indexTopic, null)"
                              v-on:keyup="keyupKeyRename(e)"
                              v-on:keyup.enter="iTopic.status = false; RenameTopicStream(iTopic.topicID, iTopic.keyTopic, iTopic.topicName, indexTopic, null)"></v-text-field>
                          </span>
                          <v-menu bottom left>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn dark icon v-bind="attrs" v-on="on" style=" width: 11%;    height: 25px;   ">
                                <v-icon>mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-item link
                                @keydown.enter.prevent="RenameClick(iTopic, 'TopicId_' + iTopic.topicID)"
                                @keydown.space.prevent="RenameClick(iTopic, 'TopicId_' + iTopic.topicID)"
                                v-on:click="RenameClick(iTopic, 'TopicId_' + iTopic.topicID)">
                                <v-list-item-title>Rename</v-list-item-title>
                              </v-list-item>
                              <v-list-item link @keydown.enter.prevent="DeleteTopicStream(iTopic.topicID, indexTopic)"
                                @keydown.space.prevent="DeleteTopicStream(iTopic.topicID, indexTopic)"
                                v-on:click="DeleteTopicStream(iTopic.topicID, indexTopic)">
                                <v-list-item-title>Delete chat</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </v-card-title>
                      </v-card>
                      <v-card v-show="iTopic.status != true" style="cursor:pointer;" tabindex="0"
                        @keydown.enter.prevent="Click_History_List(iTopic.topicID, iTopic.topicName, iTopic.topicModelID, iTopic.topicModelID_long, iTopic.keyTopic);"
                        @keydown.space.prevent="Click_History_List(iTopic.topicID, iTopic.topicName, iTopic.topicModelID, iTopic.topicModelID_long, iTopic.keyTopic);"
                        v-on:click="Click_History_List(iTopic.topicID, iTopic.topicName, iTopic.topicModelID, iTopic.topicModelID_long, iTopic.keyTopic);">
                        <v-card-title class="white--text" style="    padding: 5px;padding-left: 10px; "
                          :style="'background-color:' + (Log_History_TopicID == iTopic.topicID ? '#004e8c' : '#ff4646')">
                          <v-tooltip top open-delay="150">
                            <template v-slot:activator="{ on }">
                              <span v-on="on"
                                style=" font-size: 15px;white-space: nowrap;width: 88%;overflow: hidden;text-overflow: ellipsis;">
                                {{ iTopic.topicName }}
                              </span>
                            </template>
                            <span> {{ iTopic.topicName }}</span>
                          </v-tooltip>
                          <v-menu bottom left>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn dark icon v-bind="attrs" v-on="on" style=" width: 11%;    height: 25px;   ">
                                <v-icon>mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-item link
                                @keydown.enter.prevent="RenameClick(iTopic, 'TopicId_' + iTopic.topicID)"
                                @keydown.space.prevent="RenameClick(iTopic, 'TopicId_' + iTopic.topicID)"
                                v-on:click="RenameClick(iTopic, 'TopicId_' + iTopic.topicID)">
                                <v-list-item-title>Rename</v-list-item-title>
                              </v-list-item>
                              <v-list-item link
                                v-on:click="DeleteTopicStream(iTopic.topicID, iTopic.keyTopic, indexTopic)"
                                @keydown.enter="DeleteTopicStream(iTopic.topicID, iTopic.keyTopic, indexTopic)">
                                <v-list-item-title>Delete chat</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </v-card-title>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>

              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" sm="12" :md="showLeftPanel && !SetPopup ? 8 : 12" :lg="SetPopup ? 8 : (showLeftPanel ? 8 : 12)"
          class="pb-0 pr-0">
          <v-card id="chatSide" class="card2" style="height: auto;">
            <v-row>
              <v-col cols="12" sm="12" class="d-flex align-center justify-space-between">
                <div>
                  <h4 style="color: #171717;font-weight: 600;">Run two chat sessions at once to compare their responses
                    !</h4>
                </div>
                <div class="chat-icons">
                  <button type="button" class="first-img">
                    <v-tooltip location="top" max-width="360px">
                      <template v-slot:activator="{ props }">
                        <img v-bind="props" src="@/assets/info.png" alt="Chat commands info" width="24" height="24" />
                      </template>
                      <div>
                        <span style="font-weight: 600;">:clearmemory </span>
                        <span>{{ $t('_cmdClearMemory') }}</span>
                      </div>
                      <div>
                        <span style="font-weight: 600;">:memory </span>
                        <span>{{ $t('_cmdShowMemory') }}</span>
                      </div>
                      <div>
                        <span style="font-weight: 600;">:last memory </span>
                        <span>{{ $t('_cmdLastMemory') }}</span>
                      </div>
                    </v-tooltip>
                  </button>

                  <button type="button" class="second-img" v-if="roleId == 0 || roleId == 1"
                    v-on:click="OpenFullStream()">
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img v-bind="props" src="@/assets/Ai Chat bot icon.svg" alt="Enter chat mode" width="28"
                          height="28" />
                      </template>
                      <span>{{ $t('enterChatMode') }}</span>
                    </v-tooltip>
                  </button>

                  <button type="button" @click="showLeftPanel = !showLeftPanel" class="third-img">
                    <img v-if="showLeftPanel" src="@/assets/Expander_Chat Playground.svg" alt="Collapse side panel"
                      width="26" height="26" style="margin-top: 4px;" />

                    <div v-else class="third-img-active">
                      <img src="@/assets/expander-active.png" alt="Expand side panel" width="16" height="16" />
                    </div>
                  </button>
                </div>
              </v-col>
            </v-row>
            <div class="mt-3">
              <hr>
            </div>

            <v-row class="mt-2 model-select-row">
              <v-col cols="12" sm="12" md="6">
                <div>
                  <span class="header">Model A</span>
                  <span class="model-required">*</span>
                </div>

                <div class="model-select-body">
                  <div class="model-select-field">
                    <v-autocomplete ref="model" :placeholder="$t('modelName')" :items="playgroundModelSelectorOptions"
                      item-title="label" item-value="value" hide-details variant="none" :class="[
                        'model-name-field-fluid',
                        showModelWarning && !configLeft.model ? 'warning-border' : ''
                      ]" v-model="leftModelSelector" @update:model-value="savechange($event, 'Left')"
                      density="compact">
                    </v-autocomplete>
                    <div v-if="showModelWarning && (!configLeft.model)" class="warning-group">
                      <span style="color: #3859D0; font-size: 10px; font-weight: 500;">Choose a model to start chatting
                        with the
                        Bot.</span>
                    </div>
                  </div>

                  <div :class="showModelWarning && (!configLeft.model) ? 'is-warning' : ''">
                    <div :class="showModelWarning && (!configLeft.model) ? 'warning-button' : 'model-button'">
                      <v-tooltip location="top" v-if="configLeft.model == '' || configLeft.model == null">
                        <template v-slot:activator="{ props }">
                          <button type="button" v-bind="props" @click="CreateDialog('Left')">
                            <img class="model-icon" src="@/assets/Create Model icon-Dual Chat.svg" alt="img" width="24"
                              height="24" />
                          </button>
                        </template>
                        <span>{{ $t('create') }}</span>
                      </v-tooltip>
                      <v-tooltip location="top" v-else>
                        <template v-slot:activator="{ props }">
                          <button type="button" v-bind="props" class="text-primary" @click="EditDialog('Left')">
                            <img class="model-icon" src="@/assets/Edit.svg" alt="img" width="20" height="20" />
                          </button>
                        </template>
                        <span>{{ $t('edit') }}</span>
                      </v-tooltip>
                      <v-tooltip location="top">
                        <template v-slot:activator="{ props }">
                          <button type="button" :disabled="configLeft.model == '' || configLeft.model == null"
                            v-bind="props" @click="Save('Left')">
                            <img v-if="configLeft.modelDisplay || configLeft.modelName" class="model-icon"
                              src="@/assets/basil_save-outline.svg" alt="img" width="20" height="20" />
                            <img v-else class="model-icon" src="@/assets/Save-Dual chat.svg" alt="img" width="20"
                              height="20" />
                          </button>
                        </template>
                        <span>{{ $t('save') }}</span>
                      </v-tooltip>
                    </div>
                  </div>
                </div>

              </v-col>

              <v-col cols="12" sm="12" md="6">
                <div>
                  <span class="header">Model B</span>
                  <span class="model-required">*</span>
                </div>

                <div class="model-select-body">
                  <div class="model-select-field">
                    <v-autocomplete ref="model" :placeholder="$t('modelName')" :items="playgroundModelSelectorOptions"
                      item-title="label" item-value="value" hide-details variant="none" :class="[
                        'model-name-field-fluid',
                        showModelWarning && !configRight.model ? 'warning-border' : ''
                      ]" v-model="rightModelSelector" @update:model-value="savechange($event, 'Right')"
                      density="compact">
                    </v-autocomplete>
                    <div v-if="showModelWarning && (!configRight.model)" class="warning-group">
                      <span style="color: #3859D0; font-size: 10px; font-weight: 500;">Choose a model to start chatting
                        with the
                        Bot.</span>
                    </div>
                  </div>

                  <div :class="showModelWarning && (!configRight.model) ? 'is-warning' : ''">
                    <div :class="showModelWarning && (!configRight.model) ? 'warning-button' : 'model-button'">
                      <v-tooltip location="top" v-if="configRight.model == '' || configRight.model == null">
                        <template v-slot:activator="{ props }">
                          <button type="button" v-bind="props" @click="CreateDialog('Right')">
                            <img class="model-icon" src="@/assets/Create Model icon-Dual Chat.svg" alt="img" width="24"
                              height="24" />
                          </button>
                        </template>
                        <span>{{ $t('create') }}</span>
                      </v-tooltip>
                      <v-tooltip location="top" v-else>
                        <template v-slot:activator="{ props }">
                          <button type="button" v-bind="props" @click="EditDialog('Right')">
                            <img class="model-icon" src="@/assets/Edit.svg" alt="img" width="20" height="20" />
                          </button>
                        </template>
                        <span>{{ $t('edit') }}</span>
                      </v-tooltip>

                      <v-tooltip location="top">
                        <template v-slot:activator="{ props }">
                          <button type="button" :disabled="configRight.model == '' || configRight.model == null"
                            v-bind="props" @click="Save('Right')">
                            <img v-if="configRight.modelDisplay || configRight.modelName" class="model-icon"
                              src="@/assets/basil_save-outline.svg" alt="img" width="20" height="20" />
                            <img v-else class="model-icon" src="@/assets/Save-Dual chat.svg" alt="img" width="20"
                              height="20" />
                          </button>
                        </template>
                        <span>{{ $t('save') }}</span>
                      </v-tooltip>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>

            <div>
              <v-row ref="ConfigPromtAndParametersRef">
                <v-col ref="LeftConfig" cols="12" sm="12" md="6" lg="6">
                  <v-card class="parameter-card">
                    <div class="configuration-card-background" @click="panelLeft = !panelLeft">
                      <div class="config-card">
                        <img src="@/assets/config.svg" alt="img" width="20" height="20" />
                        <span class="header">Configuration A</span>
                      </div>
                      <div class="d-flex align-center">
                        <img v-if="!panelLeft" src="@/assets/arrow-drop-down.svg" alt="img" width="16" height="16" />
                        <img v-else src="@/assets/arrow-up.svg" alt="img" width="16" height="16" />
                      </div>
                    </div>

                    <div v-if="panelLeft" class="pa-3">
                      <v-row>
                        <v-col cols="12" sm="12">
                          <span class="modern-label">User Id</span>
                        </v-col>
                      </v-row>
                      <v-row style="margin-top: -20px;">
                        <v-col>
                          <v-text-field class="model-input-control" variant="none" density="compact"
                            v-model="configLeft.User_Id" hide-details style="padding-top: 0px;">
                            <template v-slot:prepend-inner>
                              <v-icon size="small" color="primary" class="mr-1">
                                mdi-account-outline
                              </v-icon>
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-textarea id="PromptTemplate-left" :placeholder="$t('PromptTemplate')"
                            v-model="configLeft.promptTemplate" :rules="[validatePrompt(configLeft.promptTemplate)]"
                            variant="none" counter auto-grow height="180px" rows="12" required
                            class="model-input-control">
                          </v-textarea>
                        </v-col>
                      </v-row>

                      <v-row class="mt-4">
                        <v-col cols="12" sm="12" md="6" :md="SetPopup ? 12 : 6" :lg="SetPopup ? 12 : 6">
                          <div class="d-flex align-center justify-start gap-2">
                            <span style="color: #171717; font-size: 12px;">Frequency Penalty (0-2)</span>
                            <v-tooltip location="top" max-width="310px">
                              <template v-slot:activator="{ props }">
                                <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18"
                                  height="18" style="cursor: pointer; margin-left: 4px;" />
                              </template>
                              <span>Controls randomness: 0= focused, 1 = creative</span>
                            </v-tooltip>
                          </div>
                          <v-text-field v-model="configLeft.temperature" density="compact" variant="none" clearable
                            @keypress="isNumber($event)" :rules="[validateInput0_1(configLeft.temperature)]" required
                            class="model-input-control mt-2">
                          </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="6" :md="SetPopup ? 12 : 6" :lg="SetPopup ? 12 : 6">
                          <div class="d-flex align-center justify-start gap-2">
                            <span style="color: #171717; font-size: 12px;">Presence Penalty (0-2)</span>
                            <v-tooltip location="top" max-width="310px">
                              <template v-slot:activator="{ props }">
                                <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18"
                                  height="18" style="cursor: pointer; margin-left: 4px;" />
                              </template>
                              <span>Nucleus sampling parameter</span>
                            </v-tooltip>
                          </div>
                          <v-text-field v-model="configLeft.topP" density="compact" variant="none" clearable required
                            :disabled="configLeft.provider == 'Anthropic'" @keypress="isNumber($event)"
                            :rules="[validateInput0_1(configLeft.topP)]" class="model-input-control mt-2">
                          </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="6" :md="SetPopup ? 12 : 6" :lg="SetPopup ? 12 : 6">
                          <div class="d-flex align-center justify-start gap-2">
                            <span style="color: #171717; font-size: 12px;">Temperature (0-1)</span>
                            <v-tooltip location="top" max-width="310px">
                              <template v-slot:activator="{ props }">
                                <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18"
                                  height="18" style="cursor: pointer; margin-left: 4px;" />
                              </template>
                              <span>Reduces repetition of frequent tokens</span>
                            </v-tooltip>
                          </div>
                          <v-text-field :disabled="configLeft.provider == 'Anthropic'"
                            v-model="configLeft.frequencyPenalty" @keypress="isNumber($event)" density="compact"
                            variant="none" clearable :rules="[validateInput0_2(configLeft.frequencyPenalty)]"
                            class="model-input-control mt-2">
                          </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="6" :md="SetPopup ? 12 : 6" :lg="SetPopup ? 12 : 6">
                          <div class="d-flex align-center justify-start gap-2">
                            <span style="color: #171717; font-size: 12px;">Top P (0-1)</span>
                            <v-tooltip location="top" max-width="310px">
                              <template v-slot:activator="{ props }">
                                <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18"
                                  height="18" style="cursor: pointer; margin-left: 4px;" />
                              </template>
                              <span>Encourages new topics and ideas</span>
                            </v-tooltip>
                          </div>
                          <v-text-field :disabled="configLeft.provider == 'Anthropic'"
                            v-model="configLeft.presencePenalty" @keypress="isNumber($event)" density="compact"
                            variant="none" clearable :rules="[validateInput0_2(configLeft.presencePenalty)]"
                            class="model-input-control mt-2">
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                  </v-card>

                  <div class="mt-4">
                    <hr class="hr-dash" />
                  </div>

                  <div class="d-flex flex-shrink-1 pb-0 pt-4" style="flex-basis:50%; gap:12px;" id="LeftChat">
                    <div class="d-flex flex-column pa-4 rounded-lg overflow-y-auto" style="width: 100%;"
                      :style="panelLeft ? 'max-height: calc(50vh); height: calc(50vh); border: 3px solid #ffffff; box-shadow: 0px 2px 8px rgba(0,0,0,0.11);' : 'max-height: 50vh; height:50vh; border: 3px solid #ffffff; box-shadow: 0px 2px 8px rgba(0,0,0,0.11);'"
                      ref="LeftChat">
                      <div v-for="(item, index) in listMessageLeft" v-bind:key="index">
                        <div class="d-flex flex-column justify-end">
                          <div class="d-flex align-center justify-end gap-2 ml-6">
                            <span style="color: #646464; font-size: 12px;">{{ new Date().toLocaleString('en-US', {
                              day:
                                '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', hour12: true
                            }) }}</span>
                            <span class="message-user" :style="messageUserStyle">{{ item.messageUser }}</span>
                          </div>
                        </div>

                        <div class="d-flex flex-column justify-start">
                          <div class="float-left">
                            <div v-if="item.status_Process == 'Process'"
                              style="font-size: 16px;    font-weight: 400;    float: left;    width: 175px;">
                              <div style="padding-top: 10px; padding-left: 10px; color: #646464;"> Finding Answer ...
                              </div>
                            </div>

                            <div v-else-if="item.status_Process == 'Send_Message' || item.status_Process == 'END'"
                              style="line-break: anywhere;
                              padding: 16px 0px; border-radius: 8px;
                              font-weight: 400; color: #171717; float: left;
                              line-height: 22px; white-space: pre-line; width: fit-content;
                              min-height: 54px; max-width: 80%;
                              overflow-wrap: break-word; word-wrap: break-word;" @click="botMessageClick($event)">
                              <MarkdownRenderer :content="item.messageBot" />
                            </div>
                            <div v-else style="line-break: anywhere;
                              padding: 16px 20px; background: rgb(249,249,249);
                              border-radius: 8px;font-weight: 400;
                              line-height: 22px; white-space:  pre-line; 
                              width: fit-content; float: left;
                              overflow-wrap: break-word; word-wrap: break-word;">
                              <MarkdownRenderer :content="item.messageBot" />
                              <span> ...{{ item.status_Process }}</span>
                            </div>
                          </div>


                        </div>
                      </div>
                      <div ref="endLeft"></div>
                    </div>
                  </div>
                </v-col>

                <v-col ref="RightConfig" cols="12" sm="12" md="6" lg="6">
                  <v-card class="parameter-card">
                    <div class="configuration-card-background" @click="panelRight = !panelRight">
                      <div class="config-card">
                        <img src="@/assets/config.svg" alt="img" width="20" height="20" />
                        <span class="header">Configuration B</span>
                      </div>
                      <div class="d-flex align-center">
                        <img v-if="!panelRight" src="@/assets/arrow-drop-down.svg" alt="img" width="16" height="16" />
                        <img v-else src="@/assets/arrow-up.svg" alt="img" width="16" height="16" />
                      </div>
                    </div>

                    <div v-if="panelRight" class="pa-3">
                      <v-row>
                        <v-col cols="12" sm="12">
                          <span class="modern-label">User Id</span>
                        </v-col>
                      </v-row>
                      <v-row style="margin-top: -20px;">
                        <v-col>
                          <v-text-field class="model-input-control" variant="none" density="compact"
                            v-model="configRight.User_Id" hide-details>
                          </v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-textarea id="PromptTemplate-right" :placeholder="$t('PromptTemplate')"
                            v-model="configRight.promptTemplate" :rules="[validatePrompt(configRight.promptTemplate)]"
                            variant="none" counter auto-grow height="180px" rows="12" required
                            class="model-input-control">
                          </v-textarea>
                        </v-col>
                      </v-row>

                      <v-row class="mt-4">
                        <v-col cols="12" sm="12" md="6" :md="SetPopup ? 12 : 6" :lg="SetPopup ? 12 : 6">
                          <div class="d-flex align-center justify-start gap-2">
                            <span style="color: #171717; font-size: 12px;">Frequency Penalty (0-2)</span>
                            <v-tooltip location="top" max-width="310px">
                              <template v-slot:activator="{ props }">
                                <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18"
                                  height="18" style="cursor: pointer; margin-left: 4px;" />
                              </template>
                              <span>Controls randomness: 0= focused, 1 = creative</span>
                            </v-tooltip>
                          </div>
                          <v-text-field v-model="configRight.temperature" density="compact" variant="none" clearable
                            @keypress="isNumber($event)" :rules="[validateInput0_1(configRight.temperature)]" required
                            class="model-input-control mt-2">
                          </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="6" :md="SetPopup ? 12 : 6" :lg="SetPopup ? 12 : 6">
                          <div class="d-flex align-center justify-start gap-2">
                            <span style="color: #171717; font-size: 12px;">Presence Penalty (0-2)</span>
                            <v-tooltip location="top" max-width="310px">
                              <template v-slot:activator="{ props }">
                                <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18"
                                  height="18" style="cursor: pointer; margin-left: 4px;" />
                              </template>
                              <span>Nucleus sampling parameter</span>
                            </v-tooltip>
                          </div>
                          <v-text-field v-model="configRight.topP" density="compact" variant="none" clearable required
                            :disabled="configRight.provider == 'Anthropic'" @keypress="isNumber($event)"
                            :rules="[validateInput0_1(configRight.topP)]" class="model-input-control mt-2">
                          </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="6" :md="SetPopup ? 12 : 6" :lg="SetPopup ? 12 : 6">
                          <div class="d-flex align-center justify-start gap-2">
                            <span style="color: #171717; font-size: 12px;">Temperature (0-1)</span>
                            <v-tooltip location="top" max-width="310px">
                              <template v-slot:activator="{ props }">
                                <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18"
                                  height="18" style="cursor: pointer; margin-left: 4px;" />
                              </template>
                              <span>Reduces repetition of frequent tokens</span>
                            </v-tooltip>
                          </div>
                          <v-text-field :disabled="configRight.provider == 'Anthropic'"
                            v-model="configRight.frequencyPenalty" @keypress="isNumber($event)" density="compact"
                            variant="none" clearable :rules="[validateInput0_2(configRight.frequencyPenalty)]"
                            class="model-input-control mt-2">
                          </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="6" :md="SetPopup ? 12 : 6" :lg="SetPopup ? 12 : 6">
                          <div class="d-flex align-center justify-start gap-2">
                            <span style="color: #171717; font-size: 12px;">Top P (0-1)</span>
                            <v-tooltip location="top" max-width="310px">
                              <template v-slot:activator="{ props }">
                                <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18"
                                  height="18" style="cursor: pointer; margin-left: 4px;" />
                              </template>
                              <span>Encourages new topics and ideas</span>
                            </v-tooltip>
                          </div>
                          <v-text-field :disabled="configRight.provider == 'Anthropic'"
                            v-model="configRight.presencePenalty" @keypress="isNumber($event)" density="compact"
                            variant="none" clearable :rules="[validateInput0_2(configRight.presencePenalty)]"
                            class="model-input-control mt-2">
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                  </v-card>

                  <div class="mt-4">
                    <hr class="hr-dash" />
                  </div>

                  <div class="d-flex flex-shrink-1 pb-0 pt-4" style="flex-basis:50%; gap:12px;" id="RightChat">
                    <div class="d-flex flex-column pa-4 rounded-lg overflow-y-auto" style="width: 100%;"
                      :style="panelRight ? 'max-height: calc(50vh); height: calc(50vh); border: 3px solid #ffffff; box-shadow: 0px 2px 8px rgba(0,0,0,0.11);' : 'max-height: 50vh; height: 50vh; border: 3px solid #ffffff; box-shadow: 0px 2px 8px rgba(0,0,0,0.11);'"
                      ref="RightChat">
                      <div v-for="(item, index) in listMessageRight" v-bind:key="index">
                        <div class="d-flex flex-column justify-end">
                          <div class="d-flex align-center justify-end gap-2 ml-6">
                            <span style="color: #646464; font-size: 12px;">{{ new Date().toLocaleString('en-US', {
                              day:
                                '2-digit', month: 'short', hour: '2-digit', minute: '2-digit', hour12: true
                            }) }}</span>
                            <span class="message-user" :style="messageUserStyle">{{ item.messageUser }}</span>
                          </div>
                        </div>

                        <div class="d-flex flex-column justify-start">
                          <div class="float-left">
                            <div v-if="item.status_Process == 'Process'"
                              style="font-size: 16px;    font-weight: 400;    float: left;    width: 175px;">
                              <div style="padding-top: 10px; padding-left: 10px; color: #646464;"> Finding Answer ...
                              </div>
                            </div>

                            <div v-else-if="item.status_Process == 'Send_Message' || item.status_Process == 'END'"
                              style="line-break: anywhere;
                              padding: 16px 0px; border-radius: 8px;
                              font-weight: 400; color: #171717; float: left;
                              line-height: 22px; white-space: pre-line; width: fit-content;
                              min-height: 54px; max-width: 80%;
                              overflow-wrap: break-word; word-wrap: break-word;" @click="botMessageClick($event)">
                              <MarkdownRenderer :content="item.messageBot" />
                            </div>
                            <div v-else style="line-break: anywhere;
                              padding: 16px 20px; background: rgb(249,249,249);
                              border-radius: 8px; font-weight: 400;
                              line-height: 22px; white-space:  pre-line; 
                              width: fit-content; float: left;
                              overflow-wrap: break-word; word-wrap: break-word;">
                              <MarkdownRenderer :content="item.messageBot" />
                              <span> ...{{ item.status_Process }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div ref="endRight"></div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>



            <div class="d-flex flex-wrap flex-row mt-6" ref="TextRef">
              <div class="d-flex justify-start align-center chat-input-row" style="gap: 12px;">
                <button type="button" v-on:click="Clear_listMessage">
                  <v-tooltip location="top" max-width="230px">
                    <template v-slot:activator="{ props }">
                      <img v-if="hasChatHistory" v-bind="props" src="@/assets/Chat Service _ Clean icon_Active.svg"
                        alt="img" width="30" height="30" />
                      <img v-else v-bind="props" src="@/assets/Chat Service _ Clean icon_Disable.svg" alt="img"
                        width="30" height="30" />
                    </template>
                    <span>Removes the visible chat history from the screen, resetting the conversation view.</span>
                  </v-tooltip>
                </button>
                <!-- Textarea Container (like Stream.vue's textarea-waveform-container) -->
                <div class="textarea-waveform-container">
                  <v-textarea ref="RefMessageData"
                    :class="[showLeftPanel && !SetPopup ? 'custom-chat-textarea' : 'custom-chat-textarea-large']"
                    v-model="messageData" background-color="transparent" :placeholder="$t('typeYourMessage')"
                    variant="solo" flat auto-grow rows="1" max-rows="6" clearable :color="selectedColor"
                    @click:clear="messageData = ''" v-on:keydown.enter.shift="Key_Ctrl_Flag = true"
                    v-on:keyup.enter.shift="Shift_Enter_MessageData"
                    @keydown.enter.exact.prevent="SendMessage('Enter'); Key_Ctrl_Flag = false;"
                    hide-details>
                  </v-textarea>
<div class="d-flex align-center gap-2">
                      <!-- Send Button -->
                      <button 
                        v-show="!isAnyProcessing && isAnyCanSend"
                        type="button" 
                        class="send-button" 
                        :disabled="!canSendMessage"
                        @click="canSendMessage ? SendMessage('click') : null"
                        @mouseenter="isSendHover = true" 
                        @mouseleave="isSendHover = false">
                        <div class="send-image-button" :class="{
                          'disabled': !canSendMessage,
                          'active': canSendMessage
                        }"></div>
                        <v-tooltip activator="parent" location="top">
                          {{ $t('sendMessage') }}
                        </v-tooltip>
                      </button>
                      <!-- Stop Button -->
                      <v-btn 
                        v-show="isAnyProcessing && messageData.length === 0"
                        v-on:click="StopMessage" 
                        @keydown.enter.prevent="StopMessage" 
                        @keydown.space.prevent="StopMessage"
                        icon variant="flat" size="small" class="stop-button">
                        <v-icon size="18" :color="selectedColor">mdi-stop-circle-outline</v-icon>
                        <v-tooltip activator="parent" location="top">
                          Stop generation
                        </v-tooltip>
                      </v-btn>
                    </div>
                </div>
              </div>

              <div class="mt-2 mr-4" style="width: 100%; display: flex; justify-content: end;">
                <span class="playground-char-counter" :class="{ 'playground-char-counter--over': isOverCharLimit }">{{
                  messageData.length }} / {{ maxCharacter }}</span>
              </div>

              <!-- ไม่ตัดข้อความให้แล้ว ผู้ใช้จึงต้องเห็นว่าเกินเท่าไหร่และต้องตัดเองก่อนส่ง -->
              <div v-if="isOverCharLimit" class="playground-char-limit-warning">
                <v-icon size="14" color="#DC2626">mdi-alert-circle-outline</v-icon>
                <span>{{ $t('_charLimitOver', {
                  max: convertNumberToStringFormat(maxCharacter),
                  over: convertNumberToStringFormat(messageData.length - maxCharacter)
                }) }}</span>
              </div>

              <div style="width: 100%;">
                <span style="font-size: 14px;color: #3859D0;margin-bottom: 1%;display: flex;justify-content: center;">AI
                  can
                  make mistakes. Please double-check responses.</span>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <div v-if="alertDialog"
      style="position: fixed; top: 16px; left: 50%; transform: translateX(-50%); z-index: 1000; animation: fadeDialogUp 2s ease-out;">
      <v-alert color="green" type="success" dismissible @click:close="alertDialog = false">
        The image is downloading...
      </v-alert>
    </div>

    <v-dialog v-model="CreateDialogV" width="80vw">
      <v-card>
        <v-flex justify-content-center>
          <ModelManagement style="width: 100%;" :editAction="configEdit.typeUpdate" v-model="configEdit"
            :modelID="$route.query.id" :GetDDModel="isParam" :page="'Playground Create'" @is-event="isemitEvent" />
        </v-flex>
      </v-card>
    </v-dialog>
    <v-dialog v-model="EditDialogV" width="80vw">
      <v-card>
        <v-flex justify-content-center>
          <ModelManagement style="width: 100%;" :editAction="configEdit.typeUpdate" v-model="configEdit"
            :modelID="$route.query.id" :GetDDModel="isParam" :page="'Playground Edit'" @is-event="isemitEvent" />
        </v-flex>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showImage" max-width="1000">
      <v-card style="
        height: 85vh;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: transparent;
        box-shadow: none;
        overflow: hidden;
      ">
        <v-img :src="dialogImage" contain style="
          width: 100%;
          height: 100%;
          object-fit: contain;
        " />
      </v-card>
      <div style="position: fixed; bottom: 16px; left: 50%; transform: translateX(-50%);
            display: flex; justify-content: center; gap: 8px; z-index: 1000; opacity: 0; 
            animation: fadeUp 0.3s ease forwards 0.3s;">
        <input type="file" webkitdirectory directory id="folderPicker" aria-label="Select folder"
          style="display: none;">

        <div class="downloadImgBtn" style="background-color:#faa91b;" @click="downloadImage">
          <v-icon color="white">mdi-download</v-icon>
        </div>
        <div class="downloadImgBtn" style="background-color:#FF4444;" fab @click="showImage = false">
          <v-icon color="white">mdi-close</v-icon>
        </div>
      </div>
    </v-dialog>


    <v-overlay :value="dialog">
      <v-dialog v-model="dialog" persistent width="300">
        <v-card color="#1976D2" dark>
          <v-card-text class="white--text">
            Loading Please Wait...
            <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
  </div>
</template>
<script>
import dateUtils from '../plugins/date-utils';
import moment from 'moment';
import LogTrace from '@/api/function.js';
import MarkdownRenderer from '@/components/MarkedMarkdown.vue'
// import MarkdownIt from '@/components/MarkedMarkdown.vue'
import ModelManagement from '@/components/ModelManagement.vue';
import Cookies from "js-cookie";
import { useDisplay, useGoTo } from 'vuetify';
import { DD_MODEL_OPTIONS, DD_GENDER_OPTIONS, DD_MINUTE_OPTIONS_NO_ZERO, MAX_CHAT_INPUT_LIMIT } from '@/constants/gptModelOptions';
import chatImagePreviewMixin from '@/mixins/chatImagePreviewMixin.js';
import { replaceLeadingNewlines, buildShortMemoryText } from '@/utils/chatLogText';
import { isInputTooLongError, parseServerCharLimit, normalizeCharacterLimit } from '@/utils/chatInputLimit';
// 2. เรียกใช้ useGoTo เพื่อเอาฟังก์ชัน goTo มาใช้งาน

const API_BASE_URL = import.meta.env?.VITE_APP_API

const createDefaultModelConfig = () => ({
  typeUpdate: false,
  side: '',
  User_Id: '',
  typeLLM: 0,
  modelId: 0,
  modelIDGroup: null,
  modelDisplay: null,
  modelNameDisplay: null,
  modelName: '',
  provider: '',
  platform: null,
  model: '',
  APIVersion: null,
  EndPointURL: null,
  endPointURL: null,
  API_Key: null,
  apI_Key: null,
  authenHeaderName: null,
  extension: null,
  description: null,
  gender: 'm',
  versioning: 1,
  typingSpeed: 40,
  maximumChatInput: 200000,
  isStream: true,
  IsBypass: null,
  isFeedback: null,
  isPublish: true,
  isAllowImage: null,
  isAllowLLMChange: false,
  fileUploadLimit: null,
  vectordbName: [],
  groupReplaceID: [],
  productGroupID: [],
  topVDB: null,
  Cosine: null,
  productTopVDB: null,
  productCosine: null,
  LenChainMassage: null,
  TimeSecondChainMassage: null,
  IsChainMassage: null,
  historyCount: 2,
  historyMinute: 10,
  Len_ShortMemory: 200,
  IsLongTerm_Memory: false,
  temperature: 0,
  topP: 0,
  frequencyPenalty: null,
  presencePenalty: null,
  maxTokens: null,
  stop: null,
  DataIntegrationID: null,
  SqlModelID: null,
  promptSqlNoData: null,
  IntentGroupID: null,
  promptTemplate: '',
  loadingBarFlag: false,
  loadingBarDuration: 0,
  forbiddenWord: [''],
  isShowNameUserMonitor: false,
  monitorLineUserID: null,
  monitorSocialID: null,
  guardRailModelID: null,
  enableTime: null,
  timeZone: null,
  reasoningEffort: null,
  flowGroupID: null,
  modelType: null,
  styleImage: null,
  resFormatImage: null,
  quality: null,
  resolution: null,
  jsonRequest: null,
});

const cloneConfigArray = (value, fallback = []) => Array.isArray(value) ? [...value] : [...fallback];

const normalizePlaygroundModelConfig = (config = {}, overrides = {}) => {
  const base = createDefaultModelConfig();
  const normalized = {
    ...base,
    ...config,
    vectordbName: cloneConfigArray(config.vectordbName, base.vectordbName),
    groupReplaceID: cloneConfigArray(config.groupReplaceID, base.groupReplaceID),
    productGroupID: cloneConfigArray(config.productGroupID, base.productGroupID),
    forbiddenWord: cloneConfigArray(config.forbiddenWord, base.forbiddenWord),
    APIVersion: config.APIVersion ?? config.apiVersion ?? base.APIVersion,
    EndPointURL: config.EndPointURL ?? config.endPointURL ?? base.EndPointURL,
    endPointURL: config.endPointURL ?? config.EndPointURL ?? base.endPointURL,
    API_Key: config.API_Key ?? config.apI_Key ?? base.API_Key,
    apI_Key: config.apI_Key ?? config.API_Key ?? base.apI_Key,
    presencePenalty: config.presencePenalty ?? config.presence_penalty ?? base.presencePenalty,
    authenHeaderName: config.authenHeaderName ?? base.authenHeaderName,
    platform: config.platform ?? base.platform,
    jsonRequest: config.jsonRequest ?? config.JsonRequest ?? base.jsonRequest,
  };

  const merged = {
    ...normalized,
    ...overrides,
  };

  const endpoint = merged.endPointURL ?? merged.EndPointURL ?? null;
  const apiKey = merged.apI_Key ?? merged.API_Key ?? null;

  return {
    ...merged,
    EndPointURL: endpoint,
    endPointURL: endpoint,
    API_Key: apiKey,
    apI_Key: apiKey,
    vectordbName: cloneConfigArray(merged.vectordbName, base.vectordbName),
    groupReplaceID: cloneConfigArray(merged.groupReplaceID, base.groupReplaceID),
    productGroupID: cloneConfigArray(merged.productGroupID, base.productGroupID),
    forbiddenWord: cloneConfigArray(merged.forbiddenWord, base.forbiddenWord),
  };
};

// ค่าเริ่มต้นของ DataLogLeft/DataLogRight ใน data() — คืน object ใหม่ทุกครั้ง
const createInitialDataLog = () => ({
  Prompt: "",
  Vector: "",
  ReplySQL: "",
  ReplyDataSelect: "",
  Memory: "",
  Translate: "",
  FlowActionIntent: "",
  GPT_Model: {
    modelId: "",
    modelName: "",
    Provider: "",
    model: "",
    extension: "",
    description: "",
    promptTemplate: "",
    gender: "",
    vectordbName: "",
    topVDB: "",
    productTopVDB: "",
    productCosine: "",
    internet: "",
    feedback: "",
    historyCount: "",
    historyMinute: "",
    temperature: "",
    topP: "",
    frequency_penalty: "",
    presence_penalty: "",
    Stop: "",
    maxTokens: "",
    isStream: "",
    EndpointURL: "",
    loadingBarFlag: false,
    loadingBarDuration: 0,
    forbiddenWord: [""],
  },
  Text: "",
  TextVector: "",
  VectorCoise: "",
  Private_Memory: "",
});

// DataLog เปล่าที่ใช้ตอน reset (key set นี้ใช้ซ้ำแบบเหมือนกันทุกตัวอักษรใน 2 จุด;
// จุด reset อื่นมี key set ต่างกัน (เช่น stop/Stop, loadingBar, vectordbName) จึงคงไว้ inline ตามเดิม)
const createEmptyStreamDataLog = () => ({
  Prompt: "",
  Vector: "",
  ReplySQL: "",
  ReplyDataSelect: "",
  Memory: "",
  Translate: "",
  FlowActionIntent: "",
  GPT_Model: {
    modelId: "",
    modelName: "",
    Provider: "",
    model: "",
    extension: "",
    description: "",
    promptTemplate: "",
    gender: "",
    vectordbName: "",
    productGroupID: "",
    topVDB: "",
    Cosine: "",
    productTopVDB: "",
    productCosine: "",
    internet: "",
    feedback: "",
    historyCount: "",
    historyMinute: "",
    temperature: "",
    topP: "",
    frequency_penalty: "",
    presence_penalty: "",
    stop: "",
    maxTokens: "",
    isStream: "",
    EndpointURL: ""
  },
  Text: "",
  VectorCoise: "",
  Private_Memory: ""
});

export default {
  mixins: [LogTrace, chatImagePreviewMixin],
  inject: ['flagNav', 'Status_Error', 'Time_Delay', 'IconChat', 'ChatbotName', 'colorThemeChat'
    , 'SetPopup', 'NavbarBtnColorTheme', 'ModelFirst', 'TopicName', 'listTopic'
    , 'Click_History_List', 'DeleteTopicStream', 'RenameClick', 'Log_History_TopicID'
    , 'RenameTopicStream', 'keyupKeyRename', 'auth_token', 'KeyTopic'
    , 'TopicModelID', 'TopicModelID_long', 'StatusKeyRename', 'GetModelFirst_Value'
    , 'Log_History_ID', 'Log_History_Take', 'GetModelFirst', 'isImgIconChat', 'ChatbotIcon', 'FontColorTitle', 'SubNavbarBackGround', 'ChatPanelFontColorTheme'],
  name: 'TestComponentPlayGround',
  components: {
    MarkdownRenderer,
    ModelManagement
  },
  setup() {
    // ใช้ useDisplay เพื่อเข้าถึง breakpoint
    const goTo = useGoTo()
    const display = useDisplay()
    return { display, goTo }
  },
  data() {
    return {
      showSuccess: false,
      _toastTimer: null,
      showLeftPanel: false,
      leftCharacter: 0,
      rightCharacter: 0,
      maxCharacter: MAX_CHAT_INPUT_LIMIT,
      // Topic management for Left and Right chat
      topicIDLeft: null,
      topicIDRight: null,
      keyTopicLeft: null,
      keyTopicRight: null,
      alertDialog: false,
      showImage: false,
      dialogImage: '',
      roleId: Cookies.get('roleId'),
      code: '',
      lineNumbers: true,
      expiryDate: '',
      rememberMe: false,
      dialog: false,
      forgotpassword: false,
      erroralert: false,
      successalert: false,
      successMessage: '',
      errorMessage: '',
      show1: false,
      Email: '',
      today: null,
      tab: null,
      showToken: false,
      selectVersion: { title: 'Versioned API v0', value: 'v0' },
      versions: [
        { title: 'Versioned API v0', value: 'v0' },
        { title: 'Versioned API v1', value: 'v1' },
      ],
      nowDate: new Date().toISOString().slice(0, 10),
      date: new Date(),
      menuCustomeDate: false,
      ListDate: [
        { title: '30 Days', value: 30 },
        { title: '60 Days', value: 60 },
        { title: '90 Days', value: 90 },
        { title: '120 Days', value: 120 }
      ],
      DateSelected: 30,
      endDate: null,
      showPass: false,
      flagAdd: false,
      addItem: {
        tokenName: '',
        eMail: '',
        endDate: '',
        apI_Key: ''
      },
      options: {},
      searchTotalTable: 0,
      itemsPerPage: 10,
      totalTable: 0,
      isFirst: true,
      id: 0,
      rules: {
        required: (value) => !!value || 'Required.',
      },

      dialogSave: false,
      DialogSide: '',
      DDVector: [],
      DDGroupReplace: [],
      DDProvider: [
        'Azure',
        'Google'
      ],
      listDataIntegration: [],
      listSqlExtract: [],
      listDDIntentGroup: [],
      DDMinute: DD_MINUTE_OPTIONS_NO_ZERO.map((o) => ({ ...o })),
      DDModel: DD_MODEL_OPTIONS.map((o) => ({ ...o })),
      DDModelShow: [],
      listDDModelDisplayName: [],
      listDDModel: [],
      listDDProvider: [],
      leftModelSelector: null,
      rightModelSelector: null,

      valid: null,
      CreateAndEditDialog: false,
      EditDialogV: false,
      CreateDialogV: false,
      selectedColor: '#FFA41E',
      panelLeft: null,
      panelRight: null,
      Topic_STATUS: false,
      LOG_STATUS_LEFT: false,
      LOG_STATUS_RIGHT: false,
      DataLogLeft: createInitialDataLog(),
      DataLogRight: createInitialDataLog(),
      anchorAttrs: {
        target: '_blank',
        rel: 'noopener noreferrer nofollow'
      },
      panel: false,
      configEdit: normalizePlaygroundModelConfig(),
      configLeft: normalizePlaygroundModelConfig({
        typeUpdate: true,
        side: 'Left',
      }),
      configRight: normalizePlaygroundModelConfig({
        typeUpdate: true,
        side: 'Right',
      }),
      listMessageLeft: [],
      listMessageRight: [],
      messageData: "",
      CountScroll: 0,
      MaxCountScroll: 15,
      messageResLeft: [],
      messageResRight: [],
      Count_messageResLeft: 0,
      Count_messageResRight: 0,
      StatusProLeft: false,
      StatusProRight: false,
      messageRunLeft: "",
      messageRunRight: "",
      messageImageLeft: "",
      messageImageRight: "",
      Stop_Flag_Left: false,
      Stop_Flag_Right: false,


      Flag_Start: false,
      parameterURL: [],
      Key_Ctrl_Flag: false,
      maxLengthChar: null,
      SessionID: null,
      isParam: "",
      isPage: "",
      maxHeight: 0,
      personalInfoToken: null,
      showTimeDelay: false,
      showModelWarning: false,
    };
  },
  mounted: function () {
    this.SessionID = this.GetUuidv4_Fun();
    this.updateHeight();
    this.GetDate();
    this.GetUuidv4();

    this.GetModel();
    this.GetDDGroupReplaceDB();
    this.GetDDLDataIntegration();
    this.GetIntentGroup();
    this.GetModelData();
    this.GetProviderData();
    this.GetDDVectorName();
    this.Themecolor();
  },
  computed: {
    // ไม่มี maxlength กันการพิมพ์แล้ว เกินเพดานได้แต่ส่งไม่ได้ ผู้ใช้ต้องตัดเอง
    isOverCharLimit() {
      return this.maxCharacter > 0 && this.messageData.length > this.maxCharacter;
    },
    canSendMessage() {
      return this.messageData.length > 0 && !this.isOverCharLimit;
    },
    DDGender() {
      return DD_GENDER_OPTIONS.map((o) => ({ id: o.id, name: this.$t(o.i18nKey) }));
    },
    ColorThemeChat() {
      return this.colorThemeChat;
    },
    messageUserStyle() {
      return {
        fontSize: '14px',
        fontWeight: 400,
        float: 'right',
        lineHeight: '22px',
        whiteSpace: 'pre-line',
        width: 'fit-content',
        minHeight: '20px',
        maxWidth: '80%',
        backgroundColor: this.selectedColor,
        color: this.ChatPanelFontColorTheme ? `#${this.ChatPanelFontColorTheme}` : '#171717',
      };
    },
    hasChatHistory() {
      return this.listMessageLeft.length > 0 || this.listMessageRight.length > 0;
    },
    getEndDate() {
      let endDate = new Date(this.date.getFullYear() + 1, this.date.getMonth(), this.date.getDate() + 1);
      return endDate.toISOString().slice(0, 10)
    },
    mdAndUp() {
      return this.display.mdAndUp.value
    },
    smAndUp() {
      return this.display.smAndUp.value
    },
    playgroundModelSelectorOptions() {
      return this.listDDModelDisplayName.map((item) => ({
        label: this.getItemModelNameText(item),
        value: item.modelDisplayID,
        modelId: item.id,
        modelName: item.name,
      }));
    },
    // Send/Stop button logic - matches Stream.vue behavior
    isAnyProcessing() {
      const leftProcessing = this.listMessageLeft.length > 0 &&
        ['Process', 'Send_Message', 'VoiceStart'].includes(this.listMessageLeft[this.listMessageLeft.length - 1].status_Process);
      const rightProcessing = this.listMessageRight.length > 0 &&
        ['Process', 'Send_Message', 'VoiceStart'].includes(this.listMessageRight[this.listMessageRight.length - 1].status_Process);
      return leftProcessing || rightProcessing;
    },
    isAnyCanSend() {
      const leftCanSend = this.listMessageLeft.length === 0 ||
        ['Stop', 'END', 'Error'].includes(this.listMessageLeft[this.listMessageLeft.length - 1].status_Process);
      const rightCanSend = this.listMessageRight.length === 0 ||
        ['Stop', 'END', 'Error'].includes(this.listMessageRight[this.listMessageRight.length - 1].status_Process);
      return leftCanSend && rightCanSend;
    }
  },
  watch: {
    colorThemeChat: {
      handler(newVal) {
        this.selectedColor = `#${newVal}`;
      },
      immediate: true
    },
    ColorThemeChat(newVal) {
      this.selectedColor = `#${newVal}`;

    },
    options: {
      handler() {
        this.GetAPIData();
      },
      deep: true,
    },
    LOG_STATUS_LEFT() {
      this.updateHeight();
    },
    LOG_STATUS_RIGHT() {
      this.updateHeight();
    },
    "SetPopup": function () {
      this.updateHeight();
    }
    // searchModel(val) {
    //   this.GetModel(val);
    // },
  },
  beforeUnmount() {
    clearTimeout(this._toastTimer);
  },
  methods: {
    getChatImageAuthToken() {
      return null;
    },
    updateHeight() {
      this.$nextTick(() => {
        const chatSide = document.getElementById('chatSide');
        if (chatSide) {
          this.maxHeight = chatSide.clientHeight;
        }
      });
    },
    Themecolor() {
      this.selectedColor = this.colorThemeChat == null ? '#FFA41E' : `#${this.colorThemeChat}`;
    },
    syncModelSelector(side) {
      const config = side === 'Left' ? this.configLeft : this.configRight;
      const selectorValue = config.typeUpdate && config.modelDisplay ? config.modelDisplay : (config.modelName || null);

      if (side === 'Left') {
        this.leftModelSelector = selectorValue;
      } else {
        this.rightModelSelector = selectorValue;
      }
    },
    resolveSelectorValue(val) {
      if (val === null || val === undefined) return '';
      if (typeof val !== 'object') return val;
      return val.value ?? val.modelDisplayID ?? val.label ?? val.title ?? val.modelName ?? '';
    },
    clearSideChatHistory(side) {
      if (side === 'Left') {
        this.listMessageLeft = [];
        this.topicIDLeft = null;
        this.keyTopicLeft = null;
      } else {
        this.listMessageRight = [];
        this.topicIDRight = null;
        this.keyTopicRight = null;
      }
    },
    resetSelectorToCurrent(side) {
      const config = side === 'Left' ? this.configLeft : this.configRight;
      const selectorValue = config.typeUpdate && config.modelDisplay ? config.modelDisplay : null;
      if (side === 'Left') {
        this.leftModelSelector = selectorValue;
      } else {
        this.rightModelSelector = selectorValue;
      }
    },
    handleModelOptionSelected(option, side) {
      const newModelId = option.modelId || option.value;
      const currentConfig = side === 'Left' ? this.configLeft : this.configRight;
      const currentModelId = currentConfig ? currentConfig.modelId : null;
      // If switching to a different model, clear previous chat history and topic for this side
      if (currentModelId && String(currentModelId) !== String(newModelId)) {
        this.clearSideChatHistory(side);
      }
      this.GetByID(newModelId, side);
    },
    savechange(val, side) {
      const normalizedValue = this.resolveSelectorValue(val);
      const option = this.playgroundModelSelectorOptions.find((item) => item.value === normalizedValue);

      if (option) {
        this.handleModelOptionSelected(option, side);
        return;
      }

      if (normalizedValue === '' || normalizedValue == null) {
        this.ClearModel(side);
        return;
      }

      this.resetSelectorToCurrent(side);
    },
    async OpenFullStream() {
      if (this.auth_token == "" || this.auth_token == null) {
        try {
          this.auth_token = "";
          await this.$call.GetTokenFullStream({}, (response) => {
            if (response.status == 0 && response.data.status) {
              this.auth_token = response.data.data;
              this.Time_Delay = response.data.timeDelay;
              let routeData = this.$router.resolve({ name: 'FullStream', query: { auth_token: response.data.data, userId: null } });
              window.open(routeData.href, '_blank');
            }
            else {
              alert(response.data.data.textError)
            }
          },
            () => {
              alert(this.$t('errorOccurred'))
            }
          );
        }
        catch {
          alert(this.$t('errorOccurred'))
        }
      }
      else {
        let routeData = this.$router.resolve({ name: 'FullStream', query: { auth_token: this.auth_token, userId: null } });
        window.open(routeData.href, '_blank');
      }
    },


    validateEmail(email) {
      // eslint-disable-next-line no-useless-escape
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //NOSONAR

      return re.test(email) || 'invalid email';
    },

    convertDateToString2(date, seperator = '-') {
      return dateUtils.getStringFromDatePickFormatDatePick2(moment(date).toDate(), seperator);
    },
    Add() {
      this.flagAdd = true;
      this.radios = 'CustomeSelectDate'
      this.dialogRenew = true;

      this.tokenName = '';
      this.email = '';
      this.EndDate = this.nowDate;
      this.addItem.endDate = this.nowDate;
    },
    copyClipboard(index, side) {
      let text = document.createElement('textarea')
      text.value = side == "left" ? this.items[this.tab].scriptAndParam[index].script : this.items[this.tab].example[index].codeEx;
      text.focus();
      document.body.appendChild(text);
      text.select();
      document.execCommand('copy');
      text.remove();
    },
    ClipboardAPIKey(index) {
      let text = this.items[this.tab].dataResponse[index].apI_Key;
      navigator.clipboard.writeText(text);
    },

    ChatRef_ScrollIntoView() {
      this.goTo(this.$refs.endLeft, { container: this.$refs.LeftChat, easing: 'linear', duration: 600 });
      this.goTo(this.$refs.endRight, { container: this.$refs.RightChat, easing: 'linear', duration: 600 });
    },
    GetUuidv4() {
      let UuidL = this.GetUuidv4_Fun();
      let UuidR = this.GetUuidv4_Fun();
      this.configLeft.User_Id = UuidL;
      this.configRight.User_Id = UuidR;
    },
    GetUuidv4_Fun() {
      let Uuid = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
      return Uuid;
    },


    async SendMessage(K_in) {
      if (this._isUnsupportedCommandSend()) {
        return;
      }
      if (this._handleNoModelSelectedWarning()) {
        return;
      }

      //Left start
      this._finalizePreviousEndMessageLeft();


      //Right start
      this._finalizePreviousEndMessageRight();
      if (this.messageData == "") {
        return;
      }
      if (this._isOverCharacterLimit()) {
        return;
      }
      if (this._shouldAbortSend()) {
        return;
      }


      let _messageData = this.messageData;
      this.messageData = "";
      this._pushMessagesAndGenerateKeyTopics(_messageData);

      setTimeout(() => {
        this.CountScroll = this.MaxCountScroll;
        this.ChatRef_ScrollIntoView();
      }, 5);

      let dataPostLeft = this._buildPlaygroundEventPayload(this.configLeft, this.configLeft.User_Id, this.topicIDLeft, this.keyTopicLeft, _messageData);

      let dataPostRight = this._buildPlaygroundEventPayload(this.configRight, this.configRight.User_Id, this.topicIDRight, this.keyTopicRight, _messageData);

      this.Stop_Flag_Left = false;
      this.StatusProLeft = true;
      this.Count_messageResLeft = 0;
      this.messageResLeft = "";

      this.Stop_Flag_Right = false;
      this.StatusProRight = true;
      this.Count_messageResRight = 0;
      this.messageResRight = "";

      this.Axios_Controller = new AbortController();

      let ConfigLeft = {
        signal: this.Axios_Controller.signal,
        onUploadProgress: () => {
          this.Text_Run('Left');
        },
        onDownloadProgress: progressEvent => {
          this._handleDownloadProgressLeft(progressEvent);
        },
        maxRedirects: 0
      }

      let ConfigRight = {
        signal: this.Axios_Controller.signal,
        onUploadProgress: () => {
          this.Text_Run('Right');
        },
        onDownloadProgress: progressEvent => {
          this._handleDownloadProgressRight(progressEvent);
        },
        maxRedirects: 0 // avoid buffering the entire stream
      }
      let chatLeftPersonalInfo = false;
      let chatRightPersonalInfo = false;

      let promise1;
      let promise2;
      if ((this.configLeft.model != '' && this.configLeft.model != null)) {
        // API LeftChat
        promise1 = this._buildChatPromise(dataPostLeft, ConfigLeft, _messageData, () => { chatLeftPersonalInfo = true; }, 'Left');
      }

      // setTimeout(() => {
      if ((this.configRight.model != '' && this.configRight.model != null)) {
        // API RightChat
        promise2 = this._buildChatPromise(dataPostRight, ConfigRight, _messageData, () => { chatRightPersonalInfo = true; }, 'Right');
      }

      // รอให้ทั้งสอง Promise เสร็จ
      await this._awaitInitialChatPromises(promise1, promise2);

      //#region Personal Information
      let retryState = { retry1: new Promise(() => { }), retry2: new Promise(() => { }) };

      if (chatLeftPersonalInfo || chatRightPersonalInfo) {
        this._setupPersonalInfoRetry({ retryState, chatLeftPersonalInfo, chatRightPersonalInfo, promise1, promise2, ConfigLeft, ConfigRight, _messageData });
      }

      await this._awaitPersonalInfoRetries(retryState, chatLeftPersonalInfo, chatRightPersonalInfo);
    },

    _buildChatPromise(dataPost, Config, _messageData, markPersonalInfo, side) {
      return new Promise((resolve, reject) => {
        this.$call.ChatPlayGroundStreamPOST(dataPost, Config, () => {
          if (this[`listMessage${side}`][this[`listMessage${side}`].length - 1].messageBot == "**#Personal Information**") //that.personalInfoToken
          {
            markPersonalInfo();
            this[`listMessage${side}`][this[`listMessage${side}`].length - 1].status_Process = "Process";
            resolve(true);
          }
          else {
            if (_messageData.trim() == ":clearhistory") {
              this.ClearChatModel(side);
              return;
            }
            this._onChatStreamSuccess(_messageData, side);
            resolve(false);
          }
        }, (_response) => {
          this._onChatStreamError(_response, side, _messageData);
          reject(false);
        });
      });
    },


    async _awaitInitialChatPromises(promise1, promise2) {
      if ((this.configLeft.model != '' && this.configLeft.model != null) && (this.configRight.model != '' && this.configRight.model != null)) {
        await Promise.all([promise1, promise2]);
      }
      else if ((this.configLeft.model != '' && this.configLeft.model != null)) {
        await promise1;
      }
      else if ((this.configRight.model != '' && this.configRight.model != null)) {
        await promise2;
      }
    },

    async _awaitPersonalInfoRetries(retryState, chatLeftPersonalInfo, chatRightPersonalInfo) {
      if (chatLeftPersonalInfo && chatRightPersonalInfo) {
        await Promise.all([retryState.retry1, retryState.retry2]);
      }
      else if (chatLeftPersonalInfo) {
        await retryState.retry1;
      }
      else if (chatRightPersonalInfo) {
        await retryState.retry2;
      }
    },

    _setupPersonalInfoRetry({ retryState, chatLeftPersonalInfo, chatRightPersonalInfo, promise1, promise2, ConfigLeft, ConfigRight, _messageData }) {
      window.open(`${API_BASE_URL}api/v0/SSO/SignInPersonalInfo`, "Popup", "width=850,height=750");

      const handleMessage = async (event) => {
        try {
          // ตรวจสอบข้อมูลจาก popup
          if (!event.data || !event.data.message) return;

          const data = event.data;
          this.personalInfoToken = data.message;
          if (chatLeftPersonalInfo) {
            retryState.retry1 = this._sendPersonalInfoRetryLeft(promise1, ConfigLeft, _messageData);
          }

          // API RightChat
          if (chatRightPersonalInfo) {
            retryState.retry2 = this._sendPersonalInfoRetryRight(promise2, ConfigRight, _messageData);
          }

        } catch (error) { //NOSONAR
        } finally {
          window.removeEventListener('message', handleMessage);
        }
      };

      window.addEventListener('message', handleMessage);
    },

    // ปุ่มส่ง disable ไว้แล้ว แต่ Enter ไม่ผ่านปุ่ม จึงต้องมีด่านนี้คู่กัน
    _isOverCharacterLimit() {
      if (!this.isOverCharLimit) {
        return false;
      }
      this.$swal.fire({
        icon: 'warning',
        title: this.$t('warning'),
        text: this.$t('_charLimitOver', {
          max: this.convertNumberToStringFormat(this.maxCharacter),
          over: this.convertNumberToStringFormat(this.messageData.length - this.maxCharacter),
        }),
        showConfirmButton: false,
        timer: 3000,
      });
      return true;
    },

    _isUnsupportedCommandSend() {
      let notUseCommand = [":model", ":set", ":userid", ":delete"]
      if (notUseCommand.some((e) => (this.messageData.toLowerCase().includes(e.toLowerCase())))) {
        this.messageData = "";
        this.$swal.fire({
          icon: 'warning',
          title: this.$t('warning'),
          text: this.$t('commandNotSupported'),
          showConfirmButton: false,
          timer: 3000,
        });
        return true;
      }
      return false;
    },

    _handleNoModelSelectedWarning() {
      if ((this.configLeft.model == '' || this.configLeft.model == null) &&
        (this.configRight.model == '' || this.configRight.model == null)) {
        // No model selected on either side: show warning state on inputs
        this.showModelWarning = true;
        return true;
      } else {
        this.showModelWarning = false;
      }
      return false;
    },

    _finalizePreviousEndMessageLeft() {
      if (this.listMessageLeft.length > 0 &&
        this.listMessageLeft[this.listMessageLeft.length - 1].status_Process == 'END'
        && this.listMessageLeft[this.listMessageLeft.length - 1].messageBot != null
        && this.listMessageLeft[this.listMessageLeft.length - 1].messageBot.length < this.messageResLeft.length) {
        this.Count_messageResLeft = 0;
        this.StatusProLeft = true;
        this.listMessageLeft[this.listMessageLeft.length - 1].messageBot = this.messageResLeft;
        this.messageResLeft[this.messageResLeft.length - 1] = "";
        setTimeout(() => {
          this.CountScroll = this.MaxCountScroll;
          this.ChatRef_ScrollIntoView();
        }, 5);
      }
    },

    _finalizePreviousEndMessageRight() {
      if (this.listMessageRight.length > 0 &&
        this.listMessageRight[this.listMessageRight.length - 1].status_Process == 'END'
        && this.listMessageRight[this.listMessageRight.length - 1].messageBot != null
        && this.listMessageRight[this.listMessageRight.length - 1].messageBot.length < this.messageResRight.length) {
        this.Count_messageResRight = 0;
        this.StatusProRight = true;
        this.listMessageRight[this.listMessageRight.length - 1].messageBot = this.messageResRight;
        this.messageResRight = "";
        setTimeout(() => {
          this.CountScroll = this.MaxCountScroll;
          this.ChatRef_ScrollIntoView();
        }, 5);

      }
    },

    _shouldAbortSend() {
      return ((this.messageData == "" || (this.listMessageLeft.length > 0 &&
        (this.listMessageLeft[this.listMessageLeft.length - 1].status_Process != 'END'
          && this.listMessageLeft[this.listMessageLeft.length - 1].status_Process != 'Error'
          && this.listMessageLeft[this.listMessageLeft.length - 1].status_Process != 'Stop'))) &&

        (this.messageData == "" || (this.listMessageRight.length > 0 &&
          (this.listMessageRight[this.listMessageRight.length - 1].status_Process != 'END'
            && this.listMessageRight[this.listMessageRight.length - 1].status_Process != 'Error'
            && this.listMessageRight[this.listMessageRight.length - 1].status_Process != 'Stop'))));
    },

    _pushMessagesAndGenerateKeyTopics(_messageData) {
      if (this.configLeft.model != '' && this.configLeft.model != null) {
        this.listMessageLeft.push({
          messageUser: _messageData,
          messageBot: '',
          status_Process: 'Process'
        })
      }
      if (this.configRight.model != '' && this.configRight.model != null) {
        this.listMessageRight.push({
          messageUser: _messageData,
          messageBot: '',
          status_Process: 'Process'
        })
      }

      // Generate keyTopic if not exists (for first message in conversation)
      if (this.configLeft.model != '' && this.configLeft.model != null && !this.keyTopicLeft) {
        this.keyTopicLeft = this.GetUuidv4_Fun();
      }
      if (this.configRight.model != '' && this.configRight.model != null && !this.keyTopicRight) {
        this.keyTopicRight = this.GetUuidv4_Fun();
      }
    },

    _onChatStreamSuccess(_messageData, side) {
      this[`StatusPro${side}`] = false;
      this.successalert = true;

      // Just mark as END - let Text_Run finish displaying remaining characters naturally
      const msgList = this[`listMessage${side}`];
      const lastIndex = msgList.length - 1;
      if (lastIndex >= 0) {
        msgList[lastIndex].status_Process = "END";
      }
      this[`GetLogStream${side}`](_messageData);
      setTimeout(() => {
        this.CountScroll = this.MaxCountScroll;
        this.ChatRef_ScrollIntoView();
      }, 5);
    },
    _onChatStreamError(_response, side, _messageData) {
      this.erroralert = true;
      this[`StatusPro${side}`] = false;

      // backend ปฏิเสธเพราะข้อความยาวเกิน MaximumChatInput ของโมเดล ไม่ใช่ error ทั่วไป
      const isInputTooLong = isInputTooLongError(_response);
      const serverLimit = isInputTooLong ? parseServerCharLimit(_response, this.maxCharacter) : this.maxCharacter;
      // backend เป็นเจ้าของเพดานจริง sync ค่าของฝั่งที่โดนปฏิเสธแล้วคิดเพดานรวมใหม่
      if (isInputTooLong) {
        this[`${side.toLowerCase()}Character`] = serverLimit;
        this.setMaxCharacter();
      }
      const errorText = isInputTooLong
        ? this.$t('_chatMessageTooLong', { max: this.convertNumberToStringFormat(serverLimit) })
        : "Error something went wrong ...";

      const msgList = this[`listMessage${side}`];
      const lastIndex = msgList.length - 1;
      
      if (lastIndex >= 0) {
        if (this[`Stop_Flag_${side}`]) {
          msgList[lastIndex].status_Process = "Stop";
        } else {
          // เคสยาวเกินไม่มีคำตอบบางส่วนให้เก็บ และ body ที่ progress handler เขียนไว้เป็นรหัสดิบ จึงทับทั้งก้อน
          msgList[lastIndex].messageBot = isInputTooLong
            ? errorText
            : (this[`messageRes${side}`] || msgList[lastIndex].messageBot) + "<br />" + errorText;
          msgList[lastIndex].status_Process = "Error";
        }
        this[`Count_messageRes${side}`] = (this[`messageRes${side}`] || '').length;
      }

      // ข้อความถูกเคลียร์ออกจากช่องพิมพ์ไปตอนกดส่ง ถ้าโดนปฏิเสธต้องคืนให้ผู้ใช้แก้ต่อ
      if (isInputTooLong && _messageData && this.messageData === "") {
        this.messageData = _messageData;
      }

      this[`Stop_Flag_${side}`] = false;
      this[`messageRes${side}`] = "";
      console.log("Error : " + _response);
      setTimeout(() => {
        this.CountScroll = this.MaxCountScroll;
        this.ChatRef_ScrollIntoView();
      }, 5);
    },

    _sendPersonalInfoRetryLeft(promise1, ConfigLeft, _messageData) {
      promise1
        .then((result) => {
        })
        .catch((error) => {
        });

      let dataPostLeft = {
        "events": [
          {
            "replyToken": "dummyToken",
            "type": "message",
            "timestamp": 1462629479859,
            "fullStream": false,
            "stream": true,
            "SessionID": this.SessionID,
            "source": {
              "type": "users",
              "userId": this.configLeft.User_Id,
              // "groupModel": this.parameterURL.groupmodel
            },

            "message": {
              "id": "325708",
              "type": "text",
              "topicID": this.topicIDLeft,
              "keyTopic": this.keyTopicLeft,
              "text": _messageData
            },
            "PersonalInfoToken": this.personalInfoToken,
            configPlayground: {
              // Default
              "typeLLM": this.configLeft.typeLLM == 1 ? 'GuardRail' : 'Bot',
              "ModelDisplay": this.configLeft.modelDisplay,
              "ModelNameDisplay": this.configLeft.modelNameDisplay,//this.configLeft.modelName,
              "ModelName": this.configLeft.modelName, //this.configLeft.modelNameDisplay,
              "Provider": this.configLeft.provider,
              "Platform": this.configLeft.platform,
              "APIVersion": this.configLeft.APIVersion,
              "Model": this.configLeft.model.split('|').length > 1 ? this.configLeft.model.split('|')[0] : this.configLeft.model,
              "EndPointURL": this.configLeft.EndPointURL,
              "API_Key": this.configLeft.API_Key,

              "Extension": this.configLeft.extension,
              "Description": this.configLeft.description,
              "gender": this.configLeft.gender,
              "Versioning": this.configLeft.versioning,
              "TypingSpeed": this.configLeft.typingSpeed,
              "maximumChatInput": this.configLeft.maximumChatInput,
              "IsStream": this.configLeft.isStream,
              // "IsBypass" : this.configLeft.IsBypass,
              "IsFeedback": this.configLeft.isFeedback,
              "IsPublish": this.configLeft.isPublish,
              "isAllowImage": this.configLeft.isAllowImage,
              "fileUploadLimit": this.configLeft.fileUploadLimit,

              // Vector
              "vectordbName": this.configLeft.vectordbName == null || JSON.stringify(this.configLeft.vectordbName) == "[]" ? null : JSON.stringify(this.configLeft.vectordbName),
              "groupReplaceID": this.configLeft.groupReplaceID == null || JSON.stringify(this.configLeft.groupReplaceID) == "[]" ? null : JSON.stringify(this.configLeft.groupReplaceID),
              "productGroupID": this.configLeft.productGroupID == null || JSON.stringify(this.configLeft.productGroupID) == "[]" ? null : JSON.stringify(this.configLeft.productGroupID),
              "TopVDB": this.configLeft.topVDB,
              "Cosine": this.configLeft.Cosine,
              "productTopVDB": this.configLeft.productTopVDB,
              "productCosine": this.configLeft.productCosine,

              "LenChainMassage": this.configLeft.LenChainMassage,
              "TimeSecondChainMassage": this.configLeft.TimeSecondChainMassage,
              "IsChainMassage": this.configLeft.IsChainMassage,

              // Memory History
              "HistoryCount": this.configLeft.historyCount,
              "HistoryMinute": this.configLeft.historyMinute > 0 ? -this.configLeft.historyMinute : this.configLeft.historyMinute,
              "Len_ShortMemory": this.configLeft.Len_ShortMemory,
              "IsLongTerm_Memory": this.configLeft.IsLongTerm_Memory,

              // Advance
              "temperature": this.configLeft.temperature,
              "top_p": this.configLeft.topP,
              "frequency_penalty": this.configLeft.frequencyPenalty,
              "presence_penalty": this.configLeft.presencePenalty,
              "max_tokens": this.configLeft.maxTokens,
              "Stop": this.configLeft.stop,

              // Data Integration
              "DataIntegrationID": this.configLeft.DataIntegrationID,
              "SqlModelID": this.configLeft.SqlModelID,
              "promptSqlNoData": this.configLeft.promptSqlNoData,
              "IntentGroupID": this.configLeft.IntentGroupID,
              "promptTemplate": this.configLeft.promptTemplate,

              //Line Config
              "loadingBarFlag": this.configLeft.loadingBarFlag,
              "loadingBarDuration": this.configLeft.loadingBarDuration,
              //"forbiddenWord": this.ConfigLeft.forbiddenWord,

              //GuradRail
              "guardRailModelID": this.configLeft.guardRailModelID,

              //Image generation
              "modelType": this.configLeft.modelType,
              "styleImage": this.configLeft.styleImage,
              "resFormatImage": this.configLeft.resFormatImage,
              "quality": this.configLeft.quality,
              "resolution": this.configLeft.resolution,

              //enableTime
              "timeZone": this.configLeft.enableTime ? this.configLeft.timeZone : null,
              "reasoningEffort": this.configLeft.reasoningEffort,
            }
          }
        ]
      };

      return this.$call.ChatPlayGroundStreamPOST(dataPostLeft, ConfigLeft, () => {
        this.StatusProLeft = false;
        this.successalert = true;
        if (this.messageResLeft != "" && this.messageResLeft != null && this.messageResLeft != undefined) {
          this.listMessageLeft[this.listMessageLeft.length - 1].messageBot = this.messageResLeft;
        }
        this.listMessageLeft[this.listMessageLeft.length - 1].status_Process = "END";
        this.GetLogStreamLeft(_messageData);
        setTimeout(() => {
          this.CountScroll = this.MaxCountScroll;
          this.ChatRef_ScrollIntoView();
        }, 5);
      }, (_response) => {
        console.log("retry1 -> Error : " + _response);
        this.erroralert = true;
        if (this.listMessageLeft.length == 0) {
          // no action needed when message list is empty
        }
        else if (this.Stop_Flag_Left && this.listMessageLeft.length > 0) {
          this.listMessageLeft[this.listMessageLeft.length - 1].status_Process = "Stop";
        }
        else {
          this.StatusProLeft = false;
          this.Count_messageResLeft = 0;
          this.messageData = "";
          if (this.listMessageLeft.length > 0 && this.listMessageLeft[this.listMessageLeft.length - 1].messageBot.length < this.messageResLeft.length) {
            this.listMessageLeft[this.listMessageLeft.length - 1].messageBot = (this.messageResLeft + "<br />Error something went wrong ...");
          }
          else {
            this.listMessageLeft[this.listMessageLeft.length - 1].messageBot += "Error something went wrong ...";
          }
          this.messageResLeft = "";
          this.listMessageLeft[this.listMessageLeft.length - 1].status_Process = "Error";
        }
        this.Stop_Flag_Left = false;
        setTimeout(() => {
          this.CountScroll = this.MaxCountScroll;
          this.ChatRef_ScrollIntoView();
        }, 5);
      });
    },
    _sendPersonalInfoRetryRight(promise2, ConfigRight, _messageData) {
      promise2
        .then((result) => {
        })
        .catch((error) => {
        });

      let dataPostRight = {
        "events": [
          {
            "replyToken": "dummyToken",
            "type": "message",
            "timestamp": 1462629479859,
            "fullStream": false,
            "stream": true,
            "SessionID": this.SessionID,
            "source": {
              "type": "users",
              "userId": this.configRight.User_Id,
            },

            "message": {
              "id": "325708",
              "type": "text",
              "topicID": this.topicIDRight,
              "keyTopic": this.keyTopicRight,
              "text": _messageData
            },
            "PersonalInfoToken": this.personalInfoToken,

            configPlayground: {
              // Default
              "typeLLM": this.configRight.typeLLM == 1 ? 'GuardRail' : 'Bot',
              "ModelDisplay": this.configRight.modelDisplay,
              "ModelNameDisplay": this.configRight.modelNameDisplay,//this.configRight.modelName,
              "ModelName": this.configRight.modelName, //this.configRight.modelNameDisplay,
              "Provider": this.configRight.provider,
              "Platform": this.configRight.platform,
              "APIVersion": this.configRight.APIVersion,
              "Model": this.configRight.model.split('|').length > 1 ? this.configRight.model.split('|')[0] : this.configRight.model,
              "EndPointURL": this.configRight.EndPointURL,
              "API_Key": this.configRight.API_Key,

              "Extension": this.configRight.extension,
              "Description": this.configRight.description,
              "gender": this.configRight.gender,
              "Versioning": this.configRight.versioning,
              "TypingSpeed": this.configRight.typingSpeed,
              "maximumChatInput": this.configRight.maximumChatInput,
              "IsStream": this.configRight.isStream,
              // "IsBypass" : this.configRight.IsBypass,
              "IsFeedback": this.configRight.isFeedback,
              "IsPublish": this.configRight.isPublish,
              "isAllowImage": this.configRight.isAllowImage,
              "fileUploadLimit": this.configRight.fileUploadLimit,

              // Vector
              "vectordbName": this.configRight.vectordbName == null || JSON.stringify(this.configRight.vectordbName) == "[]" ? null : JSON.stringify(this.configRight.vectordbName),
              "groupReplaceID": this.configRight.groupReplaceID == null || JSON.stringify(this.configRight.groupReplaceID) == "[]" ? null : JSON.stringify(this.configRight.groupReplaceID),
              "productGroupID": this.configRight.productGroupID == null || JSON.stringify(this.configRight.productGroupID) == "[]" ? null : JSON.stringify(this.configRight.productGroupID),
              "TopVDB": this.configRight.topVDB,
              "Cosine": this.configRight.Cosine,
              "productTopVDB": this.configRight.productTopVDB,
              "productCosine": this.configRight.productCosine,
              "LenChainMassage": this.configRight.LenChainMassage,
              "TimeSecondChainMassage": this.configRight.TimeSecondChainMassage,
              "IsChainMassage": this.configRight.IsChainMassage,

              // Memory History
              "HistoryCount": this.configRight.historyCount,
              "HistoryMinute": this.configRight.historyMinute > 0 ? -this.configRight.historyMinute : this.configRight.historyMinute,
              "Len_ShortMemory": this.configRight.Len_ShortMemory,
              "IsLongTerm_Memory": this.configRight.IsLongTerm_Memory,

              // Advance
              "temperature": this.configRight.temperature,
              "top_p": this.configRight.topP,
              "frequency_penalty": this.configRight.frequencyPenalty,
              "presence_penalty": this.configRight.presencePenalty,
              "max_tokens": this.configRight.maxTokens,
              "Stop": this.configRight.stop,

              // Data Integration
              "DataIntegrationID": this.configRight.DataIntegrationID,
              "SqlModelID": this.configRight.SqlModelID,
              "promptSqlNoData": this.configRight.promptSqlNoData,
              "IntentGroupID": this.configRight.IntentGroupID,
              "promptTemplate": this.configRight.promptTemplate,

              //Line Config
              "loadingBarFlag": this.configRight.loadingBarFlag,
              "loadingBarDuration": this.configRight.loadingBarDuration,
              //"forbiddenWord": this.ConfigRight.forbiddenWord,

              //GuradRail
              "guardRailModelID": this.configRight.guardRailModelID,

              //Image generation
              "modelType": this.configRight.modelType,
              "styleImage": this.configRight.styleImage,
              "resFormatImage": this.configRight.resFormatImage,
              "quality": this.configRight.quality,
              "resolution": this.configRight.resolution,

              //enableTime
              "timeZone": this.configRight.enableTime ? this.configRight.timeZone : null,
              "reasoningEffort": this.configRight.reasoningEffort,
            }
          }
        ]
      };

      return this.$call.ChatPlayGroundStreamPOST(dataPostRight, ConfigRight, () => {
        this.StatusProRight = false;
        this.successalert = true;
        this.listMessageRight[this.listMessageRight.length - 1].messageBot = this.messageResRight;
        this.listMessageRight[this.listMessageRight.length - 1].status_Process = "END";
        this.GetLogStreamRight(_messageData);
        setTimeout(() => {
          this.CountScroll = this.MaxCountScroll;
          this.ChatRef_ScrollIntoView();
        }, 5);
      }, (_response) => {
        this.erroralert = true;
        if (this.listMessageRight.length == 0) {
          // no action needed when message list is empty
        }
        else if (this.Stop_Flag_Right && this.listMessageRight.length > 0) {
          this.listMessageRight[this.listMessageRight.length - 1].status_Process = "Stop";
        }
        else {
          this.StatusProRight = false;
          this.Count_messageResRight = 0;
          this.messageData = "";
          if (this.listMessageRight.length > 0 && this.listMessageRight[this.listMessageRight.length - 1].messageBot.length < this.messageResRight.length) {
            this.listMessageRight[this.listMessageRight.length - 1].messageBot = (this.messageResRight + "<br />Error something went wrong ...");
          }
          else {
            this.listMessageRight[this.listMessageRight.length - 1].messageBot += "Error something went wrong ...";
          }
          this.messageResRight = "";
          this.listMessageRight[this.listMessageRight.length - 1].status_Process = "Error";
        }
        this.Stop_Flag_Right = false;
        setTimeout(() => {
          this.CountScroll = this.MaxCountScroll;
          this.ChatRef_ScrollIntoView();
        }, 5);
      });
    },
    _handleDownloadProgressLeft(progressEvent) {
      const xhr = (progressEvent.target == undefined ? progressEvent.event.target : progressEvent.target);
      // response ที่เป็น error (เช่น 400 ข้อความยาวเกิน) ไม่ใช่สตรีมคำตอบ ห้ามเอา body มาเรนเดอร์ลงฟองแชท
      if (xhr && xhr.status >= 400) {
        return;
      }
      try {
        const { responseText } = xhr
        if (this.listMessageLeft[this.listMessageLeft.length - 1].messageBot == "" || this.listMessageLeft[this.listMessageLeft.length - 1].messageBot == '<span class="blinking-cursor" style="">|</span>') {
          try {
            // intentionally left blank
          } catch {
          }
        }

        this.listMessageLeft[this.listMessageLeft.length - 1].status_Process = "Send_Message";

        let _responseText_Left = responseText.replaceAll("data: [DONE]", "");
        if (_responseText_Left.includes("|Products|[")) {
          const tempJson = _responseText_Left.split("|Products|");
          _responseText_Left = tempJson[0];
          this.products = JSON.parse(tempJson[1]);
        }

        /* eslint-disable no-useless-escape */
        _responseText_Left = _responseText_Left.replace(/(?:\\\\n|\\\n|\\n|\r\n|\r|\n)/g, "\n");
        _responseText_Left = _responseText_Left.replace(/(?: {6}\n| {5}\n| {4}\n| {3}\n| {2}\n| \n)/g, "\n");
        _responseText_Left = _responseText_Left.replace(/(?:\n {6}```|\n {5}```|\n {4}```|\n {3}```|\n {2}```|\n ```)/g, "\n```");
        _responseText_Left = _responseText_Left.replaceAll(/(?:\n```\n```\n\n)/g, "\n<||End||>\n<||EndMarkdown||>\n\n");
        _responseText_Left = _responseText_Left.replaceAll(/(?:\n```\n\n)/g, "\n<||End||>\n\n");
        _responseText_Left = _responseText_Left.replace(/(?:\n```\n```python|\n {3}```\n {3}```python)/g, "\n<||StarMarkdown||>\n<||StarPython||>");
        _responseText_Left = _responseText_Left.replace(/(?:\n```\n```javascript|\n {3}```\n {3}```javascript)/g, "\n<||StarMarkdown||>\n<||StarJavascript||>");
        _responseText_Left = _responseText_Left.replaceAll(/(?:\n```\n)/g, "\n<||StarAll||>\n");
        _responseText_Left = _responseText_Left.replaceAll(/(?:\n```python)/g, "\n<||StarPython||>");
        _responseText_Left = _responseText_Left.replaceAll(/(?:\n```javascript)/g, "\n<||StarJavascript||>");
        _responseText_Left = _responseText_Left.replaceAll(/(?:\n```markdown)/g, "\n<||StarMarkdown||>");

        _responseText_Left = this._resolveMarkdownTokenPairs(_responseText_Left);
        _responseText_Left = _responseText_Left.replace(/(?:\\n\\n|\n\n)/g, "\n");
        _responseText_Left = _responseText_Left.replace(/(?:\\\```|\\```|\```)/g, "<||TextMarkdown||>");
        _responseText_Left = _responseText_Left.replace(/(?:\\\`|\\`)/g, "\\`");
        _responseText_Left = _responseText_Left.replaceAll("<||TextMarkdown||>", "\```");
        _responseText_Left = _responseText_Left.replaceAll("(```", "(\\```");
        _responseText_Left = _responseText_Left.replaceAll("(``", "(\\``");
        _responseText_Left = _responseText_Left.replaceAll("(`", "(\\`");
        _responseText_Left = _responseText_Left.replaceAll("` ` `", "`` ` ``");

        if (_responseText_Left.indexOf("<!DOCTYPE html>") == 0 && !_responseText_Left.includes("```html\n<!DOCTYPE html>")
          && !_responseText_Left.includes("```\n<!DOCTYPE html>") && _responseText_Left.indexOf("<style>" != -1)) {
          let Sp_responseTextStart_Left = _responseText_Left.split("<style>");
          let Sp_responseTextEnd_Left = Sp_responseTextStart_Left[1].split("</style>");
          if (Sp_responseTextEnd_Left.length > 0) {
            Sp_responseTextEnd_Left[0] = Sp_responseTextEnd_Left[0].replaceAll("}\n", "}\n  #V_markDown ");
          }
          _responseText_Left = Sp_responseTextStart_Left[0] + "<style> #V_markDown " + Sp_responseTextEnd_Left[0] +
            (Sp_responseTextEnd_Left.length > 1 ? " </style> " + Sp_responseTextEnd_Left[1] : "")
        }
        if (_responseText_Left.includes("|Text|*Streaming:true*|")) {
          _responseText_Left = _responseText_Left.replaceAll("|Text|*Streaming:true*|", "");
          this.listMessageLeft[this.listMessageLeft.length - 1].messageBot = _responseText_Left;
          this.messageResLeft = _responseText_Left;
          this.Count_messageResLeft = 0;
          this.StatusProLeft = false;
        }
        else if (_responseText_Left.includes("|Text|*Streaming:false*|")) {
          _responseText_Left = _responseText_Left.replaceAll("|Text|*Streaming:false*|", "");
          this.listMessageLeft[this.listMessageLeft.length - 1].messageBot = _responseText_Left;
          this.messageResLeft = _responseText_Left;
          this.Count_messageResLeft = 0;
          this.StatusProLeft = false;
        }
        else {
          this.messageResLeft = _responseText_Left;
          this.StatusProLeft = true;
        }

      } catch (e) {
        this.DataLogLeft = {
          Prompt: "",
          Vector: "",
          ReplySQL: "",
          ReplyDataSelect: "",
          Memory: "",
          Translate: "",
          FlowActionIntent: "",
          GPT_Model: {
            modelId: "",
            modelName: "",
            Provider: "",
            model: "",
            extension: "",
            description: "",
            promptTemplate: "",
            gender: "",
            vectordbName: "",
            productGroupID: "",
            topVDB: "",
            Cosine: "",
            productTopVDB: "",
            productCosine: "",
            internet: "",
            feedback: "",
            historyCount: "",
            historyMinute: "",
            temperature: "",
            topP: "",
            frequency_penalty: "",
            presence_penalty: "",
            stop: "",
            maxTokens: "",
            isStream: "",
            EndpointURL: "",
            loadingBarFlag: false,
            loadingBarDuration: 0,
          },
          Text: "",
          VectorCoise: "",
          Private_Memory: ""
        };
        console.log(e)
      }
    },
    _handleDownloadProgressRight(progressEvent) {
      const xhr = (progressEvent.target == undefined ? progressEvent.event.target : progressEvent.target);
      // response ที่เป็น error (เช่น 400 ข้อความยาวเกิน) ไม่ใช่สตรีมคำตอบ ห้ามเอา body มาเรนเดอร์ลงฟองแชท
      if (xhr && xhr.status >= 400) {
        return;
      }
      try {
        const { responseText } = xhr

        if (this.listMessageRight[this.listMessageRight.length - 1].messageBot == "" || this.listMessageRight[this.listMessageRight.length - 1].messageBot == '<span class="blinking-cursor" style="">|</span>') {
          try {
            // intentionally left blank
          } catch {
          }
        }


        this.listMessageRight[this.listMessageRight.length - 1].status_Process = "Send_Message";
        let _responseText_Right = responseText.replaceAll("data: [DONE]", "");
        if (_responseText_Right.includes("|Products|[")) {
          const tempJson = _responseText_Right.split("|Products|");
          _responseText_Right = tempJson[0];
          this.products = JSON.parse(tempJson[1]);
        }

        /* eslint-disable no-useless-escape */
        _responseText_Right = _responseText_Right.replace(/(?:\\\\n|\\\n|\\n|\r\n|\r|\n)/g, "\n");
        _responseText_Right = _responseText_Right.replace(/(?: {6}\n| {5}\n| {4}\n| {3}\n| {2}\n| \n)/g, "\n");
        _responseText_Right = _responseText_Right.replace(/(?:\n {6}```|\n {5}```|\n {4}```|\n {3}```|\n {2}```|\n ```)/g, "\n```");
        _responseText_Right = _responseText_Right.replaceAll(/(?:\n```\n```\n\n)/g, "\n<||End||>\n<||EndMarkdown||>\n\n");
        _responseText_Right = _responseText_Right.replaceAll(/(?:\n```\n\n)/g, "\n<||End||>\n\n");
        _responseText_Right = _responseText_Right.replace(/(?:\n```\n```python|\n {3}```\n {3}```python)/g, "\n<||StarMarkdown||>\n<||StarPython||>");
        _responseText_Right = _responseText_Right.replace(/(?:\n```\n```javascript|\n {3}```\n {3}```javascript)/g, "\n<||StarMarkdown||>\n<||StarJavascript||>");
        _responseText_Right = _responseText_Right.replaceAll(/(?:\n```\n)/g, "\n<||StarAll||>\n");
        _responseText_Right = _responseText_Right.replaceAll(/(?:\n```python)/g, "\n<||StarPython||>");
        _responseText_Right = _responseText_Right.replaceAll(/(?:\n```javascript)/g, "\n<||StarJavascript||>");
        _responseText_Right = _responseText_Right.replaceAll(/(?:\n```markdown)/g, "\n<||StarMarkdown||>");

        _responseText_Right = this._resolveMarkdownTokenPairs(_responseText_Right);
        _responseText_Right = _responseText_Right.replace(/(?:\\n\\n|\n\n)/g, "\n");
        _responseText_Right = _responseText_Right.replace(/(?:\\\```|\\```|\```)/g, "<||TextMarkdown||>");
        _responseText_Right = _responseText_Right.replace(/(?:\\\`|\\`)/g, "\\`");
        _responseText_Right = _responseText_Right.replaceAll("<||TextMarkdown||>", "\```");
        _responseText_Right = _responseText_Right.replaceAll("(```", "(\\```");
        _responseText_Right = _responseText_Right.replaceAll("(``", "(\\``");
        _responseText_Right = _responseText_Right.replaceAll("(`", "(\\`");
        _responseText_Right = _responseText_Right.replaceAll("` ` `", "`` ` ``");

        if (_responseText_Right.indexOf("<!DOCTYPE html>") == 0 && !_responseText_Right.includes("```html\n<!DOCTYPE html>")
          && !_responseText_Right.includes("```\n<!DOCTYPE html>") && _responseText_Right.indexOf("<style>" != -1)) {
          let Sp_responseTextStart_Right = _responseText_Right.split("<style>");
          let Sp_responseTextEnd_Right = Sp_responseTextStart_Right[1].split("</style>");
          if (Sp_responseTextEnd_Right.length > 0) {
            Sp_responseTextEnd_Right[0] = Sp_responseTextEnd_Right[0].replaceAll("}\n", "}\n  #V_markDown ");
          }
          _responseText_Right = Sp_responseTextStart_Right[0] + "<style> #V_markDown " + Sp_responseTextEnd_Right[0] +
            (Sp_responseTextEnd_Right.length > 1 ? " </style> " + Sp_responseTextEnd_Right[1] : "")
        }
        if (_responseText_Right.includes("|Text|*Streaming:true*|")) {
          _responseText_Right = _responseText_Right.replaceAll("|Text|*Streaming:true*|", "");
          this.listMessageRight[this.listMessageRight.length - 1].messageBot = _responseText_Right;
          this.messageResRight = _responseText_Right;
          this.Count_messageResRight = 0;
          this.StatusProRight = false;
        }
        else if (_responseText_Right.includes("|Text|*Streaming:false*|")) {
          _responseText_Right = _responseText_Right.replaceAll("|Text|*Streaming:false*|", "");
          this.listMessageRight[this.listMessageRight.length - 1].messageBot = _responseText_Right;
          this.messageResRight = _responseText_Right;
          this.Count_messageResRight = 0;
          this.StatusProRight = false;
        }
        else {
          this.messageResRight = _responseText_Right;
          this.StatusProRight = true;
        }

      } catch (e) {
        this.DataLogRight = createEmptyStreamDataLog();
        console.log(e)
      }
    },

    _buildPlaygroundEventPayload(config, userId, topicID, keyTopic, messageText) {
      return {
        "events": [
          {
            "replyToken": "dummyToken",
            "type": "message",
            "timestamp": 1462629479859,
            "fullStream": false,
            "stream": true,
            "SessionID": this.SessionID,
            "source": {
              "type": "users",
              "userId": userId,
              // "groupModel": this.parameterURL.groupmodel
            },

            "message": {
              "id": "325708",
              "type": "text",
              "topicID": topicID,
              "keyTopic": keyTopic,
              "text": messageText
            },
            "PersonalInfoToken": this.personalInfoToken,
            configPlayground: {
              // Default
              "typeLLM": config.typeLLM == 1 ? 'GuardRail' : 'Bot',
              "ModelDisplay": config.modelDisplay,
              "ModelNameDisplay": config.modelNameDisplay,//config.modelName,
              "ModelName": config.modelName, //config.modelNameDisplay,
              "Provider": config.provider,
              "Platform": config.platform,
              "APIVersion": config.APIVersion,
              "Model": config.model.split('|').length > 1 ? config.model.split('|')[0] : config.model,
              "EndPointURL": config.EndPointURL,
              "API_Key": config.API_Key,

              "Extension": config.extension,
              "Description": config.description,
              "gender": config.gender,
              "Versioning": config.versioning,
              "TypingSpeed": config.typingSpeed,
              "maximumChatInput": config.maximumChatInput,
              "IsStream": config.isStream,
              // "IsBypass" : config.IsBypass,
              "IsFeedback": config.isFeedback,
              "IsPublish": config.isPublish,
              "isAllowImage": config.isAllowImage,
              "fileUploadLimit": config.fileUploadLimit,

              // Vector
              "vectordbName": config.vectordbName == null || JSON.stringify(config.vectordbName) == "[]" ? null : JSON.stringify(config.vectordbName),
              "groupReplaceID": config.groupReplaceID == null || JSON.stringify(config.groupReplaceID) == "[]" ? null : JSON.stringify(config.groupReplaceID),
              "productGroupID": config.productGroupID == null || JSON.stringify(config.productGroupID) == "[]" ? null : JSON.stringify(config.productGroupID),
              "TopVDB": config.topVDB,
              "Cosine": config.Cosine,
              "productTopVDB": config.productTopVDB,
              "productCosine": config.productCosine,

              "LenChainMassage": config.LenChainMassage,
              "TimeSecondChainMassage": config.TimeSecondChainMassage,
              "IsChainMassage": config.IsChainMassage,

              // Memory History
              "HistoryCount": config.historyCount,
              "HistoryMinute": config.historyMinute > 0 ? -config.historyMinute : config.historyMinute,
              "Len_ShortMemory": config.Len_ShortMemory,
              "IsLongTerm_Memory": config.IsLongTerm_Memory,

              // Advance
              "temperature": config.temperature,
              "top_p": config.topP,
              "frequency_penalty": config.frequencyPenalty,
              "presence_penalty": config.presencePenalty,
              "max_tokens": config.maxTokens,
              "Stop": config.stop,

              // Data Integration
              "DataIntegrationID": config.DataIntegrationID,
              "SqlModelID": config.SqlModelID,
              "promptSqlNoData": config.promptSqlNoData,
              "IntentGroupID": config.IntentGroupID,
              "promptTemplate": config.promptTemplate,
              "flowGroupID": config.flowGroupID,

              //Line Config
              "loadingBarFlag": config.loadingBarFlag,
              "loadingBarDuration": config.loadingBarDuration,
              //"forbiddenWord": config.forbiddenWord,

              //GuradRail
              "guardRailModelID": config.guardRailModelID,

              //Image generation
              "modelType": config.modelType,
              "styleImage": config.styleImage,
              "resFormatImage": config.resFormatImage,
              "quality": config.quality,
              "resolution": config.resolution,

              //enableTime
              "timeZone": config.enableTime ? config.timeZone : null,
            }
          }
        ]
      };
    },

    _resolveMarkdownTokenPairs(text) {
      let Sp_RT = text.split("<||");


      for (let I_Sp_RT = 0; I_Sp_RT < Sp_RT.length; I_Sp_RT++) {
        let Sp_Value = Sp_RT[I_Sp_RT].split("||>");
        if (I_Sp_RT >= 1 && Sp_Value.length > 1) {
          let Sp_Value_Old = Sp_RT[I_Sp_RT - 1].split("||>");
          if (Sp_Value[0].includes("End")) {
            Sp_RT[I_Sp_RT] = this._resolveEndTokenBackref(Sp_RT, I_Sp_RT, Sp_Value, Sp_Value_Old);
          }
          else if (((I_Sp_RT + 1) < Sp_RT.length) && Sp_Value[0].includes("StarAll")) {
            Sp_RT[I_Sp_RT] = this._resolveStarAllToken(Sp_RT, I_Sp_RT, Sp_Value_Old);
          }
        }
        if (I_Sp_RT == Sp_RT.length - 1) {
          text = this._joinMarkdownTokenSegments(Sp_RT);
        }
        text = this._replaceMarkdownTokens(text);
      }
      return text;
    },
    _joinMarkdownTokenSegments(Sp_RT) {
      for (let Iii_Sp_RT = 0; Iii_Sp_RT < Sp_RT.length; Iii_Sp_RT++) {
        if (Sp_RT[Iii_Sp_RT].includes("||>")) {
          Sp_RT[Iii_Sp_RT] = "<||" + Sp_RT[Iii_Sp_RT];
        }
      }
      return Sp_RT.join("");
    },
    _resolveEndTokenBackref(Sp_RT, I_Sp_RT, Sp_Value, Sp_Value_Old) {
      let result = Sp_RT[I_Sp_RT];
      for (let II_Sp_RT = I_Sp_RT - 1; II_Sp_RT > 0; II_Sp_RT--) {
        try {
          let Sp_Value_Old_Loop = Sp_RT[II_Sp_RT].split("||>");
          if (Sp_Value_Old.length > 1 && Sp_Value_Old_Loop.length > 1) {
            if (Sp_Value[0].includes("End") && Sp_Value_Old[0].includes("Star")) {
              let re_SVO = Sp_Value_Old[0].replace("Star", "End");
              result = result.replace("End||>", re_SVO + "||>");
              break;
            }
            else if (Sp_Value[0].includes("End") && Sp_Value_Old[0].includes("End")
              && Sp_Value_Old_Loop[0].includes("Star") &&
              !Sp_Value_Old_Loop[0].includes(Sp_Value_Old[0].replace("End", "Star"))
            ) {

              let re_SVO = Sp_Value_Old_Loop[0].replace("Star", "End");
              result = result.replace("End||>", re_SVO + "||>");
              break;
            }
          }
        } catch (e) { //NOSONAR
          // intentionally ignored
        }
      }
      return result;
    },
    _resolveStarAllToken(Sp_RT, I_Sp_RT, Sp_Value_Old) {
      let result = Sp_RT[I_Sp_RT];
      let Sp_Value_New = Sp_RT[I_Sp_RT + 1].split("||>");
      if (Sp_Value_Old[0].includes("Star")
        && Sp_Value_New.length > 1 && Sp_Value_New[0].includes("Star")) {
        let re_SVO = Sp_Value_Old[0].replace("Star", "End");
        result = result.replace("StarAll||>", re_SVO + "||>");
      }
      return result;
    },
    _replaceMarkdownTokens(text) {
      text = text.replaceAll("<||StarMarkdown||>", "\n`````\n");
      text = text.replaceAll("<||EndMarkdown||>", "`````\n");
      text = text.replaceAll("<||StarAll||>", "```");
      text = text.replaceAll("<||EndAll||>", "```");
      text = text.replaceAll("<||StarJavascript||>", "```javascript");
      text = text.replaceAll("<||EndJavascript||>", "```");
      text = text.replaceAll("<||StarPython||>", "```python");
      text = text.replaceAll("<||EndPython||>", "```");
      text = text.replaceAll("<||Star||>", "```");
      text = text.replaceAll("<||End||>", "```");
      return text;
    },


    Clear_listMessage() {
      try {
        if ((this.listMessageLeft.length == 0 || (this.listMessageLeft.length > 0 &&
          (this.listMessageLeft[this.listMessageLeft.length - 1].status_Process == 'Process' ||
            this.listMessageLeft[this.listMessageLeft.length - 1].status_Process == 'Send_Message' ||
            this.listMessageLeft[this.listMessageLeft.length - 1].status_Process == 'VoiceStart'))) &&
          (this.listMessageRight.length == 0 || (this.listMessageRight.length > 0 &&
            (this.listMessageRight[this.listMessageRight.length - 1].status_Process == 'Process' ||
              this.listMessageRight[this.listMessageRight.length - 1].status_Process == 'Send_Message' ||
              this.listMessageRight[this.listMessageRight.length - 1].status_Process == 'VoiceStart')))) {
          return;
        }

        let dataPostLeft = {
          "events": [
            {
              "replyToken": "dummyToken",
              "type": "message",
              "timestamp": 1462629479859,
              "fullStream": false,
              "stream": true,
              "SessionID": this.SessionID,
              "source": {
                "type": "users",
                "userId": this.configLeft.User_Id,
                // "groupModel": this.parameterURL.groupmodel
              },

              "message": {
                "id": "325708",
                "type": "text",
                "topicID": this.topicIDLeft,
                "keyTopic": this.keyTopicLeft,
                "text": ":clearhistory"
              },

              configPlayground: {
                // Default

                "ModelDisplay": this.configLeft.modelDisplay,
                "ModelNameDisplay": this.configLeft.modelNameDisplay, //this.configLeft.modelName,
                "ModelName": this.configLeft.modelName, //this.configLeft.modelNameDisplay,
                "Provider": this.configLeft.provider,
                "Platform": this.configLeft.platform,
                "Model": this.configLeft.model,
                "EndPointURL": this.configLeft.EndPointURL,
                "API_Key": this.configLeft.API_Key,
                "Extension": this.configLeft.extension,
                "Description": this.configLeft.description,
                "gender": this.configLeft.gender,
                "Versioning": this.configLeft.versioning,
                "TypingSpeed": this.configLeft.typingSpeed,
                "maximumChatInput": this.configLeft.maximumChatInput,
                "IsStream": this.configLeft.isStream,
                // "IsBypass" : this.configLeft.IsBypass,
                "IsFeedback": this.configLeft.isFeedback,
                "IsPublish": this.configLeft.isPublish,
                "isAllowImage": this.configLeft.isAllowImage,
                "fileUploadLimit": this.configLeft.fileUploadLimit,

                // Vector
                "vectordbName": JSON.stringify(this.configLeft.vectordbName),
                "groupReplaceID": JSON.stringify(this.configLeft.groupReplaceID),
                "productGroupID": JSON.stringify(this.configLeft.productGroupID),
                "TopVDB": this.configLeft.topVDB,
                "Cosine": this.configLeft.Cosine,
                "productTopVDB": this.configLeft.productTopVDB,
                "productCosine": this.configLeft.productCosine,
                "LenChainMassage": this.configLeft.LenChainMassage,
                "TimeSecondChainMassage": this.configLeft.TimeSecondChainMassage,
                "IsChainMassage": this.configLeft.IsChainMassage,

                // Memory History 
                "HistoryCount": this.configLeft.historyCount,
                "HistoryMinute": this.configLeft.historyMinute > 0 ? -this.configLeft.historyMinute : this.configLeft.historyMinute,
                "Len_ShortMemory": this.configLeft.Len_ShortMemory,
                "IsLongTerm_Memory": this.configLeft.IsLongTerm_Memory,

                // Advance
                "temperature": this.configLeft.temperature,
                "top_p": this.configLeft.topP,
                "frequency_penalty": this.configLeft.frequencyPenalty,
                "presence_penalty": this.configLeft.presencePenalty,
                "max_tokens": this.configLeft.maxTokens,
                "Stop": this.configLeft.stop,

                // Data Integration
                "DataIntegrationID": this.configLeft.DataIntegrationID,
                "SqlModelID": this.configLeft.SqlModelID,
                "promptSqlNoData": this.configLeft.promptSqlNoData,
                "IntentGroupID": this.configLeft.IntentGroupID,
                "promptTemplate": this.configLeft.promptTemplate,

                //Line Config 
                "loadingBarFlag": this.configLeft.loadingBarFlag,
                "loadingBarDuration": this.configLeft.loadingBarDuration,
                //"forbiddenWord": this.ConfigLeft.forbiddenWord,

                //enableTime
                "timeZone": this.configLeft.enableTime ? this.configLeft.timeZone : null,
              }
            }
          ]
        };

        let dataPostRight = {
          "events": [
            {
              "replyToken": "dummyToken",
              "type": "message",
              "timestamp": 1462629479859,
              "fullStream": false,
              "stream": true,
              "SessionID": this.SessionID,
              "source": {
                "type": "users",
                "userId": this.configRight.User_Id,
              },

              "message": {
                "id": "325708",
                "type": "text",
                "topicID": this.topicIDRight,
                "keyTopic": this.keyTopicRight,
                "text": ":clearhistory"
              },

              configPlayground: {
                // Default
                "ModelDisplay": this.configRight.modelDisplay,
                "ModelNameDisplay": this.configRight.modelNameDisplay, //this.configRight.modelName,
                "ModelName": this.configRight.modelName, //this.configRight.modelNameDisplay,
                "Provider": this.configRight.provider,
                "Platform": this.configRight.platform,
                "Model": this.configRight.model,
                "EndPointURL": this.configRight.EndPointURL,
                "API_Key": this.configRight.API_Key,
                "Extension": this.configRight.extension,
                "Description": this.configRight.description,
                "gender": this.configRight.gender,
                "Versioning": this.configRight.versioning,
                "TypingSpeed": this.configRight.typingSpeed,
                "maximumChatInput": this.configRight.maximumChatInput,
                "IsStream": this.configRight.isStream,
                // "IsBypass" : this.configRight.IsBypass,
                "IsFeedback": this.configRight.isFeedback,
                "IsPublish": this.configRight.isPublish,
                "isAllowImage": this.configRight.isAllowImage,
                "fileUploadLimit": this.configRight.fileUploadLimit,

                // Vector
                "vectordbName": JSON.stringify(this.configRight.vectordbName),
                "groupReplaceID": JSON.stringify(this.configRight.groupReplaceID),
                "productGroupID": JSON.stringify(this.configRight.productGroupID),
                "TopVDB": this.configRight.topVDB,
                "Cosine": this.configRight.Cosine,
                "productTopVDB": this.configLeft.productTopVDB,
                "productCosine": this.configLeft.productCosine,
                "LenChainMassage": this.configRight.LenChainMassage,
                "TimeSecondChainMassage": this.configRight.TimeSecondChainMassage,
                "IsChainMassage": this.configRight.IsChainMassage,

                // Memory History 
                "HistoryCount": this.configRight.historyCount,
                "HistoryMinute": this.configRight.historyMinute > 0 ? -this.configRight.historyMinute : this.configRight.historyMinute,
                "Len_ShortMemory": this.configRight.Len_ShortMemory,
                "IsLongTerm_Memory": this.configRight.IsLongTerm_Memory,

                // Advance
                "temperature": this.configRight.temperature,
                "top_p": this.configRight.topP,
                "frequency_penalty": this.configRight.frequencyPenalty,
                "presence_penalty": this.configRight.presencePenalty,
                "max_tokens": this.configRight.maxTokens,
                "Stop": this.configRight.stop,

                // Data Integration
                "DataIntegrationID": this.configRight.DataIntegrationID,
                "SqlModelID": this.configRight.SqlModelID,
                "promptSqlNoData": this.configRight.promptSqlNoData,
                "IntentGroupID": this.configRight.IntentGroupID,
                "promptTemplate": this.configRight.promptTemplate,

                //Line Config 
                "loadingBarFlag": this.configRight.loadingBarFlag,
                "loadingBarDuration": this.configRight.loadingBarDuration,
                // "forbiddenWord": this.ConfigRight.forbiddenWord,

                //enableTime
                "timeZone": this.configRight.enableTime ? this.configRight.timeZone : null,
              }
            }
          ]
        };


        // API LeftChat
        if ((this.configLeft.model != '' && this.configLeft.model != null)) {
          let ConfigLeft = {
            onUploadProgress: () => {
              console.log("onUploadProgress");
            },
            onDownloadProgress: () => {
              console.log("onDownloadProgress");
            },
            maxRedirects: 0 // avoid buffering the entire stream
          }
          this.$call.ChatPlayGroundStreamPOST(dataPostLeft, ConfigLeft, () => {
            this.messageData = "";
            this.listMessageLeft = [];
            this.messageResLeft = "";
            this.Count_messageResLeft = 0;
            this.StatusProLeft = false;
            this.DataLogLeft = createEmptyStreamDataLog();
          }, () => { });
        }
        // API RightChat
        if ((this.configRight.model != '' && this.configRight.model != null)) {
          let ConfigRight = {
            onUploadProgress: () => {
              console.log("onUploadProgress");
            },
            onDownloadProgress: () => {
              console.log("onDownloadProgress");
            },
            maxRedirects: 0 // avoid buffering the entire stream
          }
          this.$call.ChatPlayGroundStreamPOST(dataPostRight, ConfigRight, () => {
            this.messageData = "";
            this.listMessageRight = [];
            this.messageResRight = "";
            this.Count_messageResRight = 0;
            this.StatusProRight = false;
            this.DataLogRight = {
              Prompt: "",
              Vector: "",
              ReplySQL: "",
              ReplyDataSelect: "",
              Memory: "",
              Translate: "",
              FlowActionIntent: "",
              GPT_Model: {
                modelId: "",
                modelName: "",
                Provider: "",
                model: "",
                extension: "",
                description: "",
                promptTemplate: "",
                gender: "",
                productGroupID: "",
                topVDB: "",
                Cosine: "",
                productTopVDB: "",
                productCosine: "",
                internet: "",
                feedback: "",
                historyCount: "",
                historyMinute: "",
                temperature: "",
                topP: "",
                frequency_penalty: "",
                presence_penalty: "",
                stop: "",
                maxTokens: "",
                isStream: "",
                EndpointURL: ""
              },
              Text: "",
              VectorCoise: "",
              Private_Memory: ""
            };
          }, () => { });
        }
      } catch (ex) { console.log(ex) }
    },

    Text_Run(side) {


      this.TimeOutText_Run = setTimeout(() => {
        if (this[`listMessage${side}`].length == 0) {
          this[`StopMessage${side}`]();
          return;
        }
        // Stop when all characters processed and not currently downloading
        if (this[`Count_messageRes${side}`] >= this[`messageRes${side}`].length && !this[`StatusPro${side}`]) {
          this._stripTrailingCursor(side);
          setTimeout(() => {
            this.CountScroll = this.MaxCountScroll;
            this.ChatRef_ScrollIntoView();
          }, 5);
          return;
        }
        if (this[`Count_messageRes${side}`] < this[`messageRes${side}`].length || this[`StatusPro${side}`]) {
          this._stripTrailingCursor(side);
          if (this[`Count_messageRes${side}`] < this[`messageRes${side}`].length) {
            this[`_appendNextChunk${side}`]();
            this[`Count_messageRes${side}`]++;
            this.ChatRef_ScrollIntoView();
          }
          this[`listMessage${side}`][this[`listMessage${side}`].length - 1].messageBot += `<span class="blinking-cursor" style="">|</span>`;
          this.Text_Run(side);
        }
      }, this[`config${side}`].typingSpeed);
    },
    _stripTrailingCursor(side) {
      if (this[`listMessage${side}`][this[`listMessage${side}`].length - 1].messageBot.length > 0 && this[`listMessage${side}`][this[`listMessage${side}`].length - 1].messageBot.substring(this[`listMessage${side}`][this[`listMessage${side}`].length - 1].messageBot.length - 47, this[`listMessage${side}`][this[`listMessage${side}`].length - 1].messageBot.length) == '<span class="blinking-cursor" style="">|</span>') {
        this[`listMessage${side}`][this[`listMessage${side}`].length - 1].messageBot = this[`listMessage${side}`][this[`listMessage${side}`].length - 1].messageBot.substring(0, this[`listMessage${side}`][this[`listMessage${side}`].length - 1].messageBot.length - 47);
      }
    },
    _appendNextChunkLeft() {
      if (this.messageResLeft.length > (this.Count_messageResLeft + 5) && this.messageResLeft[this.Count_messageResLeft] == "<") {
        if (this.messageResLeft[this.Count_messageResLeft] + this.messageResLeft[this.Count_messageResLeft + 1] + this.messageResLeft[this.Count_messageResLeft + 2]
          + this.messageResLeft[this.Count_messageResLeft + 3] + this.messageResLeft[this.Count_messageResLeft + 4] + this.messageResLeft[this.Count_messageResLeft + 5]
          == "<br />") {
          this.listMessageLeft[this.listMessageLeft.length - 1].messageBot += "<br />";
          this.Count_messageResLeft += 5;
        }
        else if (this.messageResLeft[this.Count_messageResLeft] == "<") {
          this.listMessageLeft[this.listMessageLeft.length - 1].messageBot += this.messageResLeft[this.Count_messageResLeft];
        }
        else {
          this.listMessageLeft[this.listMessageLeft.length - 1].messageBot += this.messageResLeft[this.Count_messageResLeft];
        }
      } else if ((this.messageResLeft[this.Count_messageResLeft] + this.messageResLeft[this.Count_messageResLeft + 1] + this.messageResLeft[this.Count_messageResLeft + 2]
        + this.messageResLeft[this.Count_messageResLeft + 3] + this.messageResLeft[this.Count_messageResLeft + 4] + this.messageResLeft[this.Count_messageResLeft + 5]
        + this.messageResLeft[this.Count_messageResLeft + 6] + this.messageResLeft[this.Count_messageResLeft + 7] == "![Image]") || this.messageImageLeft != "") {
        let count = 0;
        for (let index = this.Count_messageResLeft; index < this.messageResLeft.length; index++) {
          const element = this.messageResLeft[index];
          this.messageImageLeft += element;
          count++;
          if (element == ")") {
            break;
          }
        }
        if (this.messageResLeft[this.Count_messageResLeft + (count - 1)] == ")") {
          this.listMessageLeft[this.listMessageLeft.length - 1].messageBot += this.messageImageLeft;
          this.messageImageLeft = "";
        }
        this.Count_messageResLeft += count - 1;
      }
      else {
        this.listMessageLeft[this.listMessageLeft.length - 1].messageBot += this.messageResLeft[this.Count_messageResLeft];
        this.messageImageLeft = "";
      }
    },
    _appendNextChunkRight() {
      if (this.messageResRight.length > (this.Count_messageResRight + 5) && this.messageResRight[this.Count_messageResRight] == "<") {
        if (this.messageResRight[this.Count_messageResRight] + this.messageResRight[this.Count_messageResRight + 1] + this.messageResRight[this.Count_messageResRight + 2]
          + this.messageResRight[this.Count_messageResRight + 3] + this.messageResRight[this.Count_messageResRight + 4] + this.messageResRight[this.Count_messageResRight + 5]
          == "<br />") {
          this.listMessageRight[this.listMessageRight.length - 1].messageBot += "<br />";
          this.Count_messageResRight += 5;
        }
        else if (this.messageResRight[this.Count_messageResRight] == "<") {
          this.listMessageRight[this.listMessageRight.length - 1].messageBot += this.messageResRight[this.Count_messageResRight];
        }
        else {
          this.listMessageRight[this.listMessageRight.length - 1].messageBot += this.messageResRight[this.Count_messageResRight];
        }
      } else if ((this.messageResRight[this.Count_messageResRight] + this.messageResRight[this.Count_messageResRight + 1] + this.messageResRight[this.Count_messageResRight + 2]
        + this.messageResRight[this.Count_messageResRight + 3] + this.messageResRight[this.Count_messageResRight + 4] + this.messageResRight[this.Count_messageResRight + 5]
        + this.messageResRight[this.Count_messageResRight + 6] + this.messageResRight[this.Count_messageResRight + 7] == "![Image]") || this.messageImageRight != "") {
        let count = 0;
        for (let index = this.Count_messageResRight; index < this.messageResRight.length; index++) {
          const element = this.messageResRight[index];
          this.messageImageRight += element;
          count++;
          if (element == ")") {
            break;
          }
        }
        if (this.messageResRight[this.Count_messageResRight + (count - 1)] == ")") {
          this.listMessageRight[this.listMessageRight.length - 1].messageBot += this.messageImageRight;
          this.messageImageRight = "";
        }
        this.Count_messageResRight += count - 1;
      }
      else {
        this.listMessageRight[this.listMessageRight.length - 1].messageBot += this.messageResRight[this.Count_messageResRight];
        this.messageImageRight = "";
      }
    },

    Replace_NewLine(input) {
      return replaceLeadingNewlines(input);
    },
    GetLogStreamLeft(_messageData) {
      let catchData = {
        Prompt: "",
        Vector: "",
        ReplySQL: "",
        ReplyDataSelect: "",
        Memory: "",
        GPT_Model: {
          modelId: "",
          modelName: "",
          Provider: "",
          model: "",
          extension: "",
          description: "",
          promptTemplate: "",
          gender: "",
          vectordbName: "",
          productGroupID: "",
          topVDB: "",
          Cosine: "",
          productTopVDB: "",
          productCosine: "",
          internet: "",
          feedback: "",
          historyCount: "",
          historyMinute: "",
          temperature: "",
          topP: "",
          frequency_penalty: "",
          presence_penalty: "",
          stop: "",
          maxTokens: "",
          isStream: "",
          EndpointURL: ""
        },
        Text: "",
        TextVector: "",
        Private_Memory: ""
      };
      this.DataLogLeft = catchData;
      try {
        let _User_Id = { UserChannel: this.configLeft.User_Id, TopicID: this.Log_History_TopicID };
        this.$call.GetLogMonitor(_User_Id, (response) => {
          try {
            if (response.status == 0 && response.data.status == true) { //NOSONAR
              let DataLog_Data = response.data.data;
              this.DataLog_Data = DataLog_Data;
              let replymsg = this._parseLogReplyMsgLeft(DataLog_Data, catchData);

              let Memory = this._buildShortMemory(DataLog_Data);
              this.DataLogLeft = {
                Prompt: replymsg.GPT_Model.promptTemplate,
                Vector: replymsg.Vector,
                ReplySQL: replymsg.ReplySQL,
                ReplyDataSelect: replymsg.ReplyDataSelect,
                Memory: Memory,
                Translate: replymsg.Translate,
                FlowActionIntent: replymsg.FlowActionIntent,
                GPT_Model: {
                  modelId: Number.parseInt(this.configLeft.modelDisplay) == null ? '-' : Number.parseInt(this.configLeft.modelDisplay),
                  modelName: replymsg.GPT_Model.ModelName,
                  Provider: replymsg.GPT_Model.Provider,
                  model: replymsg.GPT_Model.Model,
                  extension: replymsg.GPT_Model.Extension,
                  description: replymsg.GPT_Model.Description,
                  promptTemplate: replymsg.GPT_Model.promptTemplate,
                  gender: replymsg.GPT_Model.gender,
                  vectordbName: replymsg.GPT_Model.vectordbName,
                  productGroupID: replymsg.GPT_Model.productGroupID,
                  topVDB: replymsg.GPT_Model.TopVDB,
                  Cosine: replymsg.GPT_Model.Cosine,
                  productTopVDB: replymsg.GPT_Model.productTopVDB,
                  productCosine: replymsg.GPT_Model.productCosine,
                  internet: replymsg.GPT_Model.internet,
                  feedback: replymsg.GPT_Model.feedback,
                  historyCount: replymsg.GPT_Model.HistoryCount,
                  historyMinute: replymsg.GPT_Model.HistoryMinute,
                  temperature: replymsg.GPT_Model.temperature,
                  topP: replymsg.GPT_Model.topP,
                  frequency_penalty: replymsg.GPT_Model.frequency_penalty,
                  presence_penalty: replymsg.GPT_Model.presence_penalty,
                  stop: replymsg.GPT_Model.Stop,
                  maxTokens: replymsg.GPT_Model.max_tokens,
                  isStream: replymsg.GPT_Model.isStream,
                  EndpointURL: replymsg.GPT_Model.EndpointURL
                },
                Text: DataLog_Data.text,
                TextVector: replymsg.GPT_Model.TextVector,
                VectorCoise: replymsg.VectorCoise,
                Private_Memory: replymsg.Private_Memory

              };
            }
            else {
              this.DataLogLeft = catchData;
            }
          }
          catch {
            this.DataLogLeft = catchData;
          }
        }, () => {
          this.DataLogLeft = catchData;
        });
      }
      catch {
        this.Status_Error = true;
      }
    },
    _parseLogReplyMsgLeft(DataLog_Data, catchData) {
      let replymsg = null;
      try {
        // Save TopicID and KeyTopic from response
        if (DataLog_Data.topicID) {
          this.topicIDLeft = DataLog_Data.topicID;
        }
        if (DataLog_Data.keyTopic) {
          this.keyTopicLeft = DataLog_Data.keyTopic;
        }
        replymsg = JSON.parse(DataLog_Data.replymsg);
        replymsg.Vector = this.Replace_NewLine(replymsg.Vector);
        replymsg.VectorCoise = this.Replace_NewLine(replymsg.VectorCoise);
        replymsg.Private_Memory = this.Replace_NewLine(replymsg.Private_Memory);
        if (replymsg == null) {
          replymsg = catchData;
        }
      }
      catch {
        replymsg = {
          Vector: "",
          VectorCoise: "",
          ReplySQL: "",
          ReplyDataSelect: "",
          Private_Memory: "",
          FlowActionIntent: "",
          GPT_Model: {
            modelId: "",
            modelName: "",
            Provider: "",
            model: "",
            extension: "",
            description: "",
            promptTemplate: "",
            gender: "",
            vectordbName: "",
            productGroupID: "",
            topVDB: "",
            Cosine: "",
            productTopVDB: "",
            productCosine: "",
            internet: "",
            feedback: "",
            historyCount: "",
            historyMinute: "",
            temperature: "",
            topP: "",
            frequency_penalty: "",
            presence_penalty: "",
            stop: "",
            maxTokens: "",
            isStream: ""
          }
        }
      }
      return replymsg;
    },
    _buildShortMemory(DataLog_Data) {
      return buildShortMemoryText(DataLog_Data);
    },
    GetLogStreamRight(_messageData) {
      let catchData = {
        Prompt: "",
        Vector: "",
        ReplySQL: "",
        ReplyDataSelect: "",
        Memory: "",
        GPT_Model: {
          modelId: "",
          modelName: "",
          Provider: "",
          model: "",
          extension: "",
          description: "",
          promptTemplate: "",
          gender: "",
          vectordbName: "",
          productGroupID: "",
          topVDB: "",
          Cosine: "",
          productTopVDB: "",
          productCosine: "",
          internet: "",
          feedback: "",
          historyCount: "",
          historyMinute: "",
          temperature: "",
          topP: "",
          frequency_penalty: "",
          presence_penalty: "",
          Stop: "",
          maxTokens: "",
          isStream: "",
          EndpointURL: ""
        },
        Text: "",
        TextVector: "",
        Private_Memory: ""
      };
      this.DataLogRight = catchData;
      try {
        let _User_Id = { UserChannel: this.configRight.User_Id, TopicID: this.Log_History_TopicID };
        this.$call.GetLogMonitor(_User_Id, (response) => {
          try {
            if (response.status == 0 && response.data.status == true) { //NOSONAR
              let DataLog_Data = response.data.data;
              this.DataLog_Data = DataLog_Data;
              let replymsg = this._parseLogReplyMsgRight(DataLog_Data, catchData);

              let Memory = this._buildShortMemory(DataLog_Data);
              this.DataLogRight = {
                Prompt: replymsg.GPT_Model.promptTemplate,
                Vector: replymsg.Vector,
                ReplySQL: replymsg.ReplySQL,
                ReplyDataSelect: replymsg.ReplyDataSelect,
                Memory: Memory,
                Translate: replymsg.Translate,
                FlowActionIntent: replymsg.FlowActionIntent,
                GPT_Model: {
                  modelId: Number.parseInt(this.configRight.modelDisplay) == null ? '-' : Number.parseInt(this.configRight.modelDisplay),
                  modelName: replymsg.GPT_Model.ModelName,
                  Provider: replymsg.GPT_Model.Provider,
                  model: replymsg.GPT_Model.Model,
                  extension: replymsg.GPT_Model.Extension,
                  description: replymsg.GPT_Model.Description,
                  promptTemplate: replymsg.GPT_Model.promptTemplate,
                  gender: replymsg.GPT_Model.gender,
                  vectordbName: replymsg.GPT_Model.vectordbName,
                  productGroupID: replymsg.GPT_Model.productGroupID,
                  topVDB: replymsg.GPT_Model.TopVDB,
                  Cosine: replymsg.GPT_Model.Cosine,
                  productTopVDB: replymsg.GPT_Model.productTopVDB,
                  productCosine: replymsg.GPT_Model.productCosine,
                  internet: replymsg.GPT_Model.internet,
                  feedback: replymsg.GPT_Model.feedback,
                  historyCount: replymsg.GPT_Model.HistoryCount,
                  historyMinute: replymsg.GPT_Model.HistoryMinute,
                  temperature: replymsg.GPT_Model.temperature,
                  topP: replymsg.GPT_Model.topP,
                  frequency_penalty: replymsg.GPT_Model.frequency_penalty,
                  presence_penalty: replymsg.GPT_Model.presence_penalty,
                  Stop: replymsg.GPT_Model.Stop,
                  maxTokens: replymsg.GPT_Model.max_tokens,
                  isStream: replymsg.GPT_Model.isStream,
                  EndpointURL: replymsg.GPT_Model.EndpointURL
                },
                Text: DataLog_Data.text,
                TextVector: replymsg.GPT_Model.TextVector,
                VectorCoise: replymsg.VectorCoise,
                Private_Memory: replymsg.Private_Memory

              };
            }
            else {
              this.DataLogRight = catchData;
            }
          }
          catch {
            this.DataLogRight = catchData;
          }
        }, () => {
          this.DataLogRight = catchData;
        });
      }
      catch {
        this.Status_Error = true;
      }
    },
    _parseLogReplyMsgRight(DataLog_Data, catchData) {
      let replymsg = null;
      try {
        // Save TopicID and KeyTopic from response
        if (DataLog_Data.topicID) {
          this.topicIDRight = DataLog_Data.topicID;
        }
        if (DataLog_Data.keyTopic) {
          this.keyTopicRight = DataLog_Data.keyTopic;
        }
        replymsg = JSON.parse(DataLog_Data.replymsg);
        replymsg.Vector = this.Replace_NewLine(replymsg.Vector);
        replymsg.VectorCoise = this.Replace_NewLine(replymsg.VectorCoise);
        replymsg.Private_Memory = this.Replace_NewLine(replymsg.Private_Memory);
        if (replymsg == null) {
          replymsg = catchData;
        }
      }
      catch {
        replymsg = {
          Vector: "",
          VectorCoise: "",
          Private_Memory: "",
          GPT_Model: {
            modelId: "",
            modelName: "",
            Provider: "",
            model: "",
            extension: "",
            description: "",
            promptTemplate: "",
            gender: "",
            vectordbName: "",
            productGroupID: "",
            topVDB: "",
            Cosine: "",
            productTopVDB: "",
            productCosine: "",
            internet: "",
            feedback: "",
            historyCount: "",
            historyMinute: "",
            temperature: "",
            topP: "",
            frequency_penalty: "",
            presence_penalty: "",
            Stop: "",
            maxTokens: "",
            isStream: "",
            EndpointURL: ""
          }
        }
      }
      return replymsg;
    },
    StopMessage() {
      this.StopMessageLeft()
      this.StopMessageRight()
    },
    StopMessageLeft() {
      if (this.listMessageLeft.length == 0 ||
        (this.listMessageLeft.length > 0 && (
          this.listMessageLeft[this.listMessageLeft.length - 1].status_Process == 'Stop' ||
          this.listMessageLeft[this.listMessageLeft.length - 1].status_Process == 'END' ||
          this.listMessageLeft[this.listMessageLeft.length - 1].status_Process == 'Error')
        )
      ) {
        return;
      }
      // stop Text_Run 
      if (this.TimeOutText_Run != null) {

        clearTimeout(this.TimeOutText_Run);
        this.TimeOutText_Run = null;
      }
      // stop voice
      if (this.TimeOutStop != null) {
        clearTimeout(this.TimeOutStop);
        this.TimeOutStop = null;
      }
      if (this.SpeechRecognizer != null) {

        this.listMessage.pop();

        this.SpeechRecognizer.stopContinuousRecognitionAsync();
      }
      // stop File
      if (this.Axios_ControllerAduio != null) {
        this.Axios_ControllerAduio.abort();
      }
      // strp Open ai
      if (this.Axios_Controller != null) {
        this.Axios_Controller.abort();
      }
      this.Stop_Flag_Left = true;
      if (this.listMessageLeft.length > 0 &&
        this.listMessageLeft[this.listMessageLeft.length - 1].messageBot.length < this.messageResLeft.length) {
        this.listMessageLeft[this.listMessageLeft.length - 1].messageBot = this.messageResLeft;
      }
      if (this.listMessageLeft.length > 0 &&
        this.listMessageLeft[this.listMessageLeft.length - 1].status_Process == 'END'
        && this.listMessageLeft[this.listMessageLeft.length - 1].messageBot != null
        && this.listMessageLeft[this.listMessageLeft.length - 1].messageBot.length < this.messageResLeft.length) {
        this.Count_messageResLeft = 0;
        this.StatusProLeft = true;
        this.messageRun = "";
        this.listMessageLeft[this.listMessageLeft.length - 1].messageBot = this.messageResLeft;
        this.messageResLeft = "";

        setTimeout(() => {
          this.CountScroll = this.MaxCountScroll;
          this.ChatRef_ScrollIntoView();
        }, 5);
        return;
      }
      if (this.listMessageLeft.length > 0) {
        this.listMessageLeft[this.listMessageLeft.length - 1].status_Process = "Stop";
      }
      this.listMessageLeft[this.listMessageLeft.length - 1].messageBot = this.listMessageLeft[this.listMessageLeft.length - 1].messageBot.replace('<span class="blinking-cursor" style="">|</span>', '');
      this.messageData = "";
      this.messageResLeft = "";
      this.Count_messageResLeft = 0;
      this.StatusProLeft = false;
    },

    StopMessageRight() {
      if (this.listMessageRight.length == 0 ||
        (this.listMessageRight.length > 0 && (
          this.listMessageRight[this.listMessageRight.length - 1].status_Process == 'Stop' ||
          this.listMessageRight[this.listMessageRight.length - 1].status_Process == 'END' ||
          this.listMessageRight[this.listMessageRight.length - 1].status_Process == 'Error')
        )
      ) {
        return;
      }
      // stop Text_Run 
      if (this.TimeOutText_Run != null) {

        clearTimeout(this.TimeOutText_Run);
        this.TimeOutText_Run = null;
      }
      // stop voice
      if (this.TimeOutStop != null) {
        clearTimeout(this.TimeOutStop);
        this.TimeOutStop = null;
      }
      if (this.SpeechRecognizer != null) {

        this.listMessageRight.pop();

        this.SpeechRecognizer.stopContinuousRecognitionAsync();
      }
      // stop File
      if (this.Axios_ControllerAduio != null) {
        this.Axios_ControllerAduio.abort();
      }
      // strp Open ai
      if (this.Axios_Controller != null) {
        this.Axios_Controller.abort();
      }
      this.Stop_Flag_Right = true;
      if (this.listMessageRight.length > 0 &&
        this.listMessageRight[this.listMessageRight.length - 1].messageBot.length < this.messageResRight.length) {
        this.listMessageRight[this.listMessageRight.length - 1].messageBot = this.messageResRight;
      }
      if (this.listMessageRight.length > 0 &&
        this.listMessageRight[this.listMessageRight.length - 1].status_Process == 'END'
        && this.listMessageRight[this.listMessageRight.length - 1].messageBot != null
        && this.listMessageRight[this.listMessageRight.length - 1].messageBot.length < this.messageResRight.length) {
        this.Count_messageResRight = 0;
        this.StatusProRight = true;
        this.messageRunRight = "";
        this.listMessageRight[this.listMessageRight.length - 1].messageBot = this.messageResRight;
        this.messageResRight = "";

        setTimeout(() => {
          this.CountScroll = this.MaxCountScroll;
          this.ChatRef_ScrollIntoView();
        }, 5);
        return;
      }
      if (this.listMessageRight.length > 0) {
        this.listMessageRight[this.listMessageRight.length - 1].status_Process = "Stop";
      }
      this.listMessageRight[this.listMessageRight.length - 1].messageBot = this.listMessageRight[this.listMessageRight.length - 1].messageBot.replace('<span class="blinking-cursor" style="">|</span>', '');
      this.messageData = "";
      this.messageResRight = "";
      this.Count_messageResRight = 0;
      this.StatusProRight = false;
    },

    Shift_Enter_MessageData() {
      this.point = this.$refs.RefMessageData.$refs.input.selectionStart;
      let _point = (this.$refs.RefMessageData.$refs.input.selectionStart - 1);
      this.$nextTick(() => {
        this.$refs.RefMessageData.$refs.input.selectionStart = _point + 2;
        this.$refs.RefMessageData.$refs.input.selectionEnd = _point + 2;
        if (this.$refs.RefMessageData.$refs.input &&
          this.$refs.RefMessageData.$refs.input.selectionStart >= this.messageData.length
        ) {
          const height = this.$refs.RefMessageData.$refs.input.scrollHeight

          // This has to be done ASAP, waiting for Vue
          // to update the DOM causes ugly layout jumping
          this.$refs.RefMessageData.$refs.input.scrollTop = height;
        }
      })
    },



    async GetlistDDGPTModelIsPublish() {
      this.dialog = true;
      await this.$call.DDGPTModel_IsPublishByUser(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            if (this.$route.query.id) {
              this.listSqlExtract = dataResponse.data.filter(e => e.id != this.$route.query.id);
            } else {
              this.listSqlExtract = dataResponse.data;
            }

          } else {
            this.listSqlExtract = [];
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },
    // Loader dropdown มาตรฐาน: เปิด dialog แล้ว assign data (หรือ []) จาก response
    async _loadDropdown(apiFn, assign) {
      this.dialog = true;
      await apiFn(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            assign(dataResponse.data);
          } else {
            assign([]);
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },
    async GetDDGroupReplaceDB() {
      await this._loadDropdown((cb, errCb) => this.$call.GetDDGroupReplaceDB(cb, errCb), (data) => { this.DDGroupReplace = data; });
    },
    async GetDDLDataIntegration() {
      await this._loadDropdown((cb, errCb) => this.$call.GetDDLDataIntegration(cb, errCb), (data) => { this.listDataIntegration = data; });
    },
    async GetModel() {
      await this.$call.DDGPTModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.listDDModelDisplayName = dataResponse.data
          } else {
            this.listDDModelDisplayName = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    async GetIntentGroup() {
      await this._loadDropdown((cb, errCb) => this.$call.DDIntentGroup(cb, errCb), (data) => { this.listDDIntentGroup = data; });
    },
    getItemModelNameText(item) {
      return `${item.modelDisplayID}: ${item.name}`;
    },
    async confirmSaveWithoutApiVersion(modelData) {

      return true;
    },
    async confirmModelUpdate(side, config) {
      const actionText = config.typeUpdate ? 'update' : 'save';
      const modelLabel = config.modelDisplay || config.modelName || (side === 'Left' ? 'Model A' : 'Model B');
      const result = await this.$swal.fire({
        icon: 'question',
        title: this.$t('warning'),
        text: this.$t('_pressOkToConfirmAction', { action: this.$t(actionText), model: modelLabel }),
        confirmButtonText: this.$t('ok'),
        cancelButtonText: this.$t('cancel'),
        showCancelButton: true,
      });

      return result.isConfirmed;
    },
    async refreshSavedModelState(side, savedModelId) {
      await Promise.all([this.GetModel(), this.GetModelData()]);

      const currentConfig = side === 'Left' ? this.configLeft : this.configRight;
      const targetModelId = savedModelId || currentConfig.modelId;

      if (!targetModelId) {
        return;
      }

      await this.GetByID(targetModelId, side);
    },
    async GetModelData() {
      this.dialog = true;
      await this.$call.GetDDLModelData(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            this.listDDModel = dataResponse.data;
          } else {
            this.listDDModel = [];
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },
    async GetProviderData() {
      this.dialog = true;
      await this.$call.GetDDLProviderData(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            this.listDDProvider = dataResponse.data;
          } else {
            this.listDDProvider = [];
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },
    async GetDDVectorName() {
      this.dialog = true;
      await this.$call.GetDDVectorDBName(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            this.DDVector = dataResponse.data;
          } else {
            this.DDVector = [];
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },

    async changeProvider(value, side = null) {
      const rightOrNull = side === 'Right' ? this.configRight : null;
      const activeConfig = side === 'Left' ? this.configLeft : rightOrNull;
      const selectedPlatform = activeConfig?.platform ?? null;

      if (value == null || value == '') {
        this.DDModelShow = [];
        return 'Required.';
      }

      this.DDModelShow = this.listDDModel.filter((item) => {
        if (item.provider != value) {
          return false;
        }

        if (!selectedPlatform) {
          return true;
        }

        return item.platform == selectedPlatform;
      });
    },
    async changeModel(value, side) {
      if (value == null || value == '') {
        this.maxLengthChar = 0;
        return 'required.';
      } else {
        let ddm = this.listDDModel.find((e) => e.modelName == value);
        if (ddm) {
          if (value == 'gpt-35-turbo') {
            this.maxLengthChar = 4000;
          } else if (value == 'gpt-35-turbo-16k') {
            this.maxLengthChar = 8000;
          } else if (value == 'gpt-4') {
            this.maxLengthChar = 6000;
          } else {
            this.maxLengthChar = null;
          }
          this.configEdit.APIVersion = ddm.apiVersion;
          if (side == 'Left') {
            this.configLeft.APIVersion = ddm.apiVersion;
          } else {
            this.configRight.APIVersion = ddm.apiVersion;
          }
        } else {
          this.maxLengthChar = null;
        }
      }
    },
    async GetByID(id, side) {
      let userID = await this.GetUuidv4_Fun();
      this.dialog = true;
      await this.$call.GetGPTModelById(
        id,
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            let response = dataResponse.data;
            let resData = this._mapResponseToModelConfig(response);
            await this._applyLoadedModelConfig(side, resData, dataResponse, userID);
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          console.error(errorResource);
        }
      );
    },
    _mapResponseToModelConfig(response) {
      const typeLLMInner = response.typeLLM == "GuardRail" ? 1 : null;
      const typeLLM = response.typeLLM == "Bot" ? 0 : typeLLMInner;
      return normalizePlaygroundModelConfig({

        // StatusforUpdate
        typeUpdate: true,
        modelIDGroup: response.modelIDGroup,

        // Default
        typeLLM,
        modelId: response.modelID,
        modelDisplay: response.modelDisplay,
        modelName: response.modelName,
        modelNameDisplay: response.modelNameDisplay,
        provider: response.provider,
        platform: response.platform,
        model: response.model,
        APIVersion: response.apiVersion,
        API_Key: response.apI_Key,
        apI_Key: response.apI_Key,
        EndPointURL: response.endPointURL,
        endPointURL: response.endPointURL,
        authenHeaderName: response.authenHeaderName,
        // GetGPTModelById
        extension: response.extension,
        description: response.description,
        gender: response.gender,
        versioning: response.versioning,
        typingSpeed: response.typingSpeed == null ? 40 : response.typingSpeed,
        maximumChatInput: response.maximumChatInput == null ? 200000 : response.maximumChatInput,
        isStream: response.isStream,
        // isBypass : response.isBypass,
        isFeedback: response.isFeedback,
        isPublish: response.isPublish,
        isAllowImage: response.isAllowImage,
        isAllowLLMChange: response.isAllowLLMChange,
        fileUploadLimit: response.fileUploadLimit,

        // Vector
        vectordbName: response.vectordbName == null ? [] : response.vectordbName,
        groupReplaceID: response.groupReplaceID == null ? [] : response.groupReplaceID,
        productGroupID: response.productGroupID == null ? [] : response.productGroupID,
        topVDB: response.topVDB,
        Cosine: response.cosine,
        productTopVDB: response.productTopVDB,
        productCosine: response.productCosine,
        LenChainMassage: response.lenChainMassage,
        TimeSecondChainMassage: response.timeSecondChainMassage,
        IsChainMassage: response.isChainMassage ?? false,

        // Memory History
        historyCount: response.historyCount,
        historyMinute: response.historyMinute < 0 ? Math.abs(response.historyMinute) : response.historyMinute,
        Len_ShortMemory: response.len_ShortMemory ?? 200,
        IsLongTerm_Memory: response.provider == 'Google' ? false : (response.isLongTerm_Memory ?? false),
        // IsLongTerm_Memory : response.isLongTerm_Memory ,

        // Advanceresponse
        temperature: response.temperature,
        topP: response.top_p,
        frequencyPenalty: response.frequency_penalty,
        presencePenalty: response.presence_penalty,
        maxTokens: response.max_tokens,
        stop: response.stop,

        // Data Integration
        DataIntegrationID: response.dataIntegrationID,
        SqlModelID: response.sqlModelID,
        promptSqlNoData: response.promptSqlNoData,
        IntentGroupID: response.intentGroupID,
        promptTemplate: response.promptTemplate,
        flowGroupID: response.flowGroupID,

        //Line Config
        loadingBarFlag: response.loadingBarFlag,
        loadingBarDuration: response.loadingBarDuration,
        forbiddenWord: response.forbiddenWord == null ? [""] : [...JSON.parse(response.forbiddenWord), ""],
        isShowNameUserMonitor: response.isShowNameUserMonitor,
        monitorLineUserID: response.monitorLineUserID,
        monitorSocialID: response.monitorSocialID,

        //guardrail
        guardRailModelID: response.guardRailModelID,

        // Image generation
        modelType: response.modelType,
        styleImage: response.styleImage,
        resolution: response.resolution,
        resFormatImage: response.resFormatImage,
        quality: response.quality,
        jsonRequest: response.jsonRequest,

        //enableTime
        timeZone: response.timeZone,
        enableTime: Boolean(response.timeZone),
        reasoningEffort: response.reasoningEffort,
      });
    },
    async _applyLoadedModelConfig(side, resData, dataResponse, userID) {
      if (side == 'Left') {
        // this.$nextTick(async ()=>{
        this.leftCharacter = normalizeCharacterLimit(dataResponse.data.maximumChatInput, MAX_CHAT_INPUT_LIMIT);
        this.setMaxCharacter();
        this.configLeft = normalizePlaygroundModelConfig(resData, {
          side,
          User_Id: userID,
        });
        this.topicIDLeft = null;
        this.keyTopicLeft = null;
        this.syncModelSelector(side);
        await this.changeProvider(this.configLeft.provider, side);
        await this.changeModel(this.configLeft.model, side);
        // })
      } else if (side == 'Right') {

        // this.$nextTick(async ()=>{
        this.rightCharacter = normalizeCharacterLimit(dataResponse.data.maximumChatInput, MAX_CHAT_INPUT_LIMIT);
        this.setMaxCharacter();
        this.configRight = normalizePlaygroundModelConfig(resData, {
          side,
          User_Id: userID,
        });
        this.topicIDRight = null;
        this.keyTopicRight = null;
        this.syncModelSelector(side);
        await this.changeProvider(this.configRight.provider, side);
        await this.changeModel(this.configRight.model, side);
        // })
      }
    },
    // ข้อความก้อนเดียวถูกส่งไปทั้งสองฝั่ง เพดานที่ใช้ได้จริงจึงเป็นค่าน้อยสุดของฝั่งที่เลือกโมเดลไว้
    // ค่า 0 = ฝั่งนั้นยังไม่ได้เลือกโมเดล ไม่ต้องเอามาคิด
    setMaxCharacter() {
      const limits = [this.leftCharacter, this.rightCharacter].filter((limit) => limit > 0);
      this.maxCharacter = limits.length > 0 ? Math.min(...limits) : MAX_CHAT_INPUT_LIMIT;
    },
    isemitEvent(val) {
      if (val && typeof val === 'object' && val.type === 'PlaygroundSaved') {
        this.refreshSavedModelState(val.side || this.configEdit.side, val.id).then(() => {
          this.CreateAndEditDialog = false;
          this.CreateDialogV = false;
          this.EditDialogV = false;
        });
      } else if (val == "SaveEdit") {
        this.SaveEdit();
      } else if (val == "Close") {
        this.CreateAndEditDialog = false;
        this.CreateDialogV = false;
        this.EditDialogV = false;
      }
    },
    async SaveEdit() {
      let modelData = normalizePlaygroundModelConfig(this.configEdit);
      if (this.configEdit.side == 'Left') {
        if (!(await this._validateModelData(modelData))) {
          return;
        }
        this.configLeft = normalizePlaygroundModelConfig(modelData, {
          side: 'Left',
        });
        this.syncModelSelector('Left');
      }
      else if (this.configEdit.side == 'Right') {
        if (!(await this._validateModelData(modelData))) {
          return;
        }
        this.configRight = normalizePlaygroundModelConfig(modelData, {
          side: 'Right',
        });
        this.syncModelSelector('Right');
      }

      this.CreateAndEditDialog = false;
      this.CreateDialogV = false;
      this.EditDialogV = false;
    },
    // ใช้ร่วมกันทั้ง SaveEdit (rangeSource = modelData) และ Save (rangeSource = config)
    async _validateModelData(modelData, rangeSource = modelData) {
      if (modelData.modelName == null || modelData.modelName == '') {
        this.$swal.fire({
          icon: 'warning',
          title: this.$t('warning'),
          text: this.$t('warningModelName'),
          showConfirmButton: false,
          timer: 3000,
        });
        return false;
      }
      else if (!modelData.provider) {
        this.$swal.fire({
          icon: 'warning',
          title: this.$t('warning'),
          text: this.$t('warningProvider'),
          showConfirmButton: false,
          timer: 3000,
        });
        return false;
      }
      else if (!modelData.model) {
        this.$swal.fire({
          icon: 'warning',
          title: this.$t('warning'),
          text: this.$t('warningModel'),
          showConfirmButton: false,
          timer: 3000,
        });
        return false;
      }
      else if (modelData.isPublish == null) {
        this.$swal.fire({
          icon: 'warning',
          title: this.$t('warning'),
          text: this.$t('warningPublish'),
          showConfirmButton: false,
          timer: 3000,
        });
        return false;
      }
      else if (
        modelData.temperature == null ||
        rangeSource.temperature < 0 ||
        rangeSource.temperature > 1 ||
        rangeSource.temperature === '') {
        this.$swal.fire({
          icon: 'warning',
          title: this.$t('warning'),
          text: this.$t('warningTemperature'),
          showConfirmButton: false,
          timer: 3000,
        });
        return false;
      }
      else if (
        modelData.topP == null ||
        rangeSource.topP < 0 ||
        rangeSource.topP > 1 ||
        rangeSource.topP === '') {
        this.$swal.fire({
          icon: 'warning',
          title: this.$t('warning'),
          text: this.$t('warningTopP'),
          showConfirmButton: false,
          timer: 3000,
        });
        return false;
      }
      else if ((modelData.topVDB == null && modelData.vectordbName.length > 0) ||
        (modelData.productTopVDB == null && modelData.productGroupID.length > 0)) {
        this.$swal.fire({
          icon: 'warning',
          title: this.$t('warning'),
          text: this.$t('warningTopVDB'),
          showConfirmButton: false,
          timer: 3000,
        });
        return false;
      }
      if (!(await this.confirmSaveWithoutApiVersion(modelData))) {
        return false;
      }
      if (typeof this.validatePrompt(modelData.promptTemplate) == 'string') {
        this.$swal.fire({
          icon: 'warning',
          title: this.$t('warning'),
          text: this.$t('_pleaseEnterCorrectFormat'),
          showConfirmButton: false,
          timer: 1800,
        });
        return false;
      }
      return true;
    },
    CreateDialog(val) {
      this.isPage = "Playground Create"
      this.CreateAndEditDialog = true;
      this.CreateDialogV = true;
      if (val == 'Left') {
        this.configEdit = normalizePlaygroundModelConfig(this.configLeft, {
          side: val,
          User_Id: this.GetUuidv4_Fun(),
          typeUpdate: false,
          forbiddenWord: [""],
          gender: 'm',
        });
      } else if (val == 'Right') {
        this.configEdit = normalizePlaygroundModelConfig(this.configRight, {
          side: val,
          User_Id: this.GetUuidv4_Fun(),
          typeUpdate: false,
          forbiddenWord: [""],
          gender: 'm',
        });
      }
    },
    EditDialog(val) {
      this.isPage = "Playground Edit"
      this.CreateAndEditDialog = true;
      this.EditDialogV = true;
      if (val == 'Left') {
        this.configEdit = normalizePlaygroundModelConfig(this.configLeft, {
          side: val,
        });
      } else if (val == 'Right') {
        this.configEdit = normalizePlaygroundModelConfig(this.configRight, {
          side: val,
        });
      }
    },
    async Save(side) {
      let typeUpdateData = false;

      let modelData = {};
      const config = normalizePlaygroundModelConfig(side === 'Left' ? this.configLeft : this.configRight, {
        side,
      });
      modelData = this._buildSaveModelData(config);

      typeUpdateData = Boolean(config.modelId) && config.typeUpdate !== false;
      if (!(await this._validateModelData(modelData, config))) {
        return;
      }
      if (!(await this.confirmModelUpdate(side, {
        ...config,
        typeUpdate: typeUpdateData,
      }))) {
        return;
      }
      this.dialog = true;
      try {
        modelData.frequencyPenalty = modelData.frequencyPenalty == "" ? null : modelData.frequencyPenalty;
        modelData.presencePenalty = modelData.presencePenalty == "" ? null : modelData.presencePenalty;
        modelData.topVDB = modelData.topVDB == "" ? null : modelData.topVDB;
        modelData.productTopVDB = modelData.productTopVDB == "" ? null : modelData.productTopVDB;
        modelData.IsLongTerm_Memory = modelData.provider == 'Google' ? false : (modelData.IsLongTerm_Memory ?? false);
        modelData.typingSpeed = Number.parseInt(modelData.typingSpeed);
        modelData.maximumChatInput = Number.parseInt(modelData.maximumChatInput);
        this.$call.AddGPTModel(
          modelData,
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              this.successMessage = typeUpdateData ? "Update Model Successfully" : dataResponse.message;
              this.showSuccess = true;
              clearTimeout(this._toastTimer);
              this._toastTimer = setTimeout(() => {
                this.showSuccess = false;
              }, 3000);
              await this.refreshSavedModelState(side, typeUpdateData ? (dataResponse.data || config.modelId) : dataResponse.data);
            }
            if (dataResponse.status == 1 && dataResponse.data.is_exist) {
              this.$swal.fire({
                icon: 'error',
                title: typeUpdateData ? this.$t('modelIdDisplayPublishExist') : this.$t('modelDisplayExist'),
                showConfirmButton: false,
                timer: 1800,
              });
            }
            this.dialog = false;
            this.dialogSave = false;
          },
          (errorResource) => {
            this.dialog = false;
            this.dialogSave = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    _buildSaveModelData(config) {
      const typeLLMInner = config.typeLLM == 1 ? "GuardRail" : null;
      const typeLLM = config.typeLLM == 0 ? "Bot" : typeLLMInner;
      return {
        typeLLM,
        modelId: config.modelId,
        modelName: config.modelName,
        provider: config.provider,
        model: config.model,
        APIVersion: config.APIVersion,
        extension: config.extension,
        description: config.description,
        promptTemplate: config.promptTemplate,
        gender: config.gender,
        vectordbName: config.vectordbName == null ? [] : config.vectordbName,
        groupReplaceID: config.groupReplaceID == null ? [] : config.groupReplaceID,
        productGroupID: config.productGroupID == null ? [] : config.productGroupID,
        topVDB: config.topVDB,
        productTopVDB: config.productTopVDB,
        productCosine: config.productCosine,
        internet: config.internet,
        feedback: config.feedback,
        historyCount: config.historyCount,
        historyMinute: config.historyMinute > 0 ? -config.historyMinute : config.historyMinute,
        temperature: config.temperature,
        topP: config.topP,
        frequencyPenalty: config.frequencyPenalty,
        presencePenalty: config.presencePenalty,
        stop: config.stop,
        maxTokens: config.maxTokens,
        isStream: config.isStream,
        isFeedback: config.isFeedback,
        isAllowImage: config.isAllowImage,
        fileUploadLimit: config.fileUploadLimit,
        versioning: config.versioning,
        isPublish: config.isPublish,
        modelIDGroup: config.modelIDGroup,
        modelDisplay: config.modelDisplay,
        Len_ShortMemory: config.Len_ShortMemory ?? 200,
        IsLongTerm_Memory: config.provider == 'Google' ? false : (config.IsLongTerm_Memory ?? false),
        IsChainMassage: config.IsChainMassage ?? false,
        LenChainMassage: config.LenChainMassage,
        TimeSecondChainMassage: config.TimeSecondChainMassage,
        Cosine: config.Cosine,
        DataIntegrationID: config.DataIntegrationID,
        SqlModelID: config.SqlModelID,
        promptSqlNoData: config.promptSqlNoData,
        IntentGroupID: config.IntentGroupID,
        typingSpeed: Number.parseInt(config.typingSpeed),
        maximumChatInput: config.maximumChatInput == null ? 200000 : Number.parseInt(config.maximumChatInput),
        loadingBarFlag: config.loadingBarFlag,
        loadingBarDuration: config.loadingBarDuration,
        isShowNameUserMonitor: config.isShowNameUserMonitor,
        monitorLineUserID: config.monitorLineUserID,
        monitorSocialID: config.monitorSocialID,
        modelType: config.modelType,
        styleImage: config.styleImage,
        resolution: config.resolution,
        resFormatImage: config.resFormatImage,
        jsonRequest: config.jsonRequest,
        quality: config.quality,
        forbiddenWord: JSON.stringify(config.forbiddenWord.filter(word => word != '')),
        timeZone: config.enableTime ? config.timeZone : null,
        reasoningEffort: config.reasoningEffort,
        isAllowLLMChange: config.isAllowLLMChange,
        guardRailModelID: config.typeLLM == 0 ? config.guardRailModelID : null,
        flowGroupID: config.flowGroupID,
        endPointURL: config.EndPointURL,
        apI_Key: config.API_Key,
        authenHeaderName: config.authenHeaderName,
        platform: config.platform,
      };
    },
    checkValidate() {
      if (this.configEdit.vectordbName != null && this.configEdit.vectordbName != '') {
        if (this.configEdit.topVDB == '' || this.configEdit.topVDB == null || Number.parseInt(this.configEdit.topVDB) == 0) {
          return "Required.";
        }
      }
      if (this.configEdit.productGroupID != null && this.configEdit.productGroupID != '') {
        if (this.configEdit.productTopVDB == '' || this.configEdit.productTopVDB == null || Number.parseInt(this.configEdit.productTopVDB) == 0) {
          return "Required.";
        }
      }
      return true;
    },
    isNumber: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46 && charCode !== 45) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    convertNumberToStringFormat(value) {
      const [intPart, decPart] = value.toString().split('.');
      const grouped = intPart.split('').reverse().join('').replace(/(\d{3})(?=\d)/g, '$1,').split('').reverse().join('');
      return decPart !== undefined ? `${grouped}.${decPart}` : grouped;
    },
    ClearModel(val) {
      let clearData = normalizePlaygroundModelConfig({
        typeUpdate: true,
        historyMinute: -10,
      });
      if (val == 'Left') {
        this.configLeft = normalizePlaygroundModelConfig(clearData, {
          side: val,
          User_Id: this.GetUuidv4_Fun(),
        });
        this.leftModelSelector = null;
        this.listMessageLeft = [];
        // Reset topic for Left chat
        this.topicIDLeft = null;
        this.keyTopicLeft = null;

        this.leftCharacter = 0;
        this.setMaxCharacter();
      } else {
        this.configRight = normalizePlaygroundModelConfig(clearData, {
          side: val,
          User_Id: this.GetUuidv4_Fun(),
        });
        this.rightModelSelector = null;
        this.listMessageRight = [];
        // Reset topic for Right chat
        this.topicIDRight = null;
        this.keyTopicRight = null;

        this.rightCharacter = 0;
        this.setMaxCharacter();
      }

      // else if(this.listMessageRight.length == 0){
      //   this.maxCharacter = this.leftCharacter;
      // }else if(this.listMessageLeft.length == 0 && this.listMessageRight.length == 0){
      //   this.leftCharacter = 0;
      //   this.rightCharacter = 0;
      //   this.maxCharacter = 200000;
      // }

    },
    validatePrompt(inputValue) {
      if (!inputValue) {
        return true;
      }
      if (this.maxLengthChar == null) {
        return true
      } else {
        return inputValue.length <= this.maxLengthChar || this.$t('_maxLengthExceeded', { max: this.convertNumberToStringFormat(this.maxLengthChar) });
      }
    },
    validateInput0_1(inputValue) {
      // ตรวจสอบว่าข้อมูลที่ป้อนเข้ามาเป็นตัวเลขที่อยู่ระหว่าง 0 ถึง 1 ที่มีทศนิยม 2 ตำ๝หน่ง
      const value = Number.parseFloat(inputValue);
      if (Number.isNaN(value)) return this.$t('Required');
      return (value >= 0 && value <= 1 && this.isTwoDecimalPlaces(value)) || this.$t('_numberBetween0And1');
    },
    validateInput0_2(inputValue) {
      // ตรวจสอบว่าข้อมูลที่ป้อนเข้ามาเป็นตัวเลขที่อยู่ระหว่าง 0 ถึง 2 ที่มีทศนิยม 2 ตำ๝หน่ง
      const value = Number.parseFloat(inputValue);
      if (Number.isNaN(value)) return true;
      return (value >= 0 && value <= 2 && this.isTwoDecimalPlaces(value)) || this.$t('_numberBetween0And1');
    },



  },
};
</script>
<style scoped>
.chat-icons {
  display: flex;
  align-items: center !important;
  justify-content: start;
  gap: 12px;
}

.first-img:hover,
.third-img-active:hover,
.third-img:hover,
.second-img:hover {
  display: flex;
  align-items: center;
  justify-content: center !important;
  background: #FDE4DF !important;
  border-radius: 20px;
  width: 40px;
  height: 40px;
}

.third-img-active {
  display: flex;
  align-items: center !important;
  justify-content: center !important;
  background: #FAADA0 !important;
  border-radius: 24px;
  width: 30px;
  height: 30px;
}

hr {
  border: none;
  border-top: 1px solid #c9c9c9;
}

.hr-dash {
  border: none;
  border-top: 1px dashed #c9c9c9;
}

.modern-name-field {
  border: 1px solid #c9c9c9;
  border-radius: 12px !important;
  background: #ffffff !important;
  height: 40px !important;
  width: 256px;
}

.modern-name-field-large {
  border: 1px solid #c9c9c9;
  border-radius: 12px !important;
  background: #ffffff !important;
  height: 40px !important;
  width: 430px;
}

@media (max-width: 767px) {
  .modern-name-field {
    width: 210px;
  }

  .modern-name-field-large {
    width: 228px;
  }
}

@media (min-width: 768px) and (max-width: 1023px) {
  .modern-name-field-large {
    width: 370px;
  }
}

@media (min-width: 1024px) {
  .modern-name-field {
    width: 140px;
  }

  .modern-name-field-large {
    width: 260px;
  }
}

@media (min-width: 1440px) and (max-width: 1279px) {
  .modern-name-field {
    width: 270px;
  }

  .modern-name-field-large {
    width: 470px;
  }
}

@media (min-width: 1280px) {
  .modern-name-field {
    width: 220px;
  }

  .modern-name-field-large {
    width: 386px;
  }
}

.warning-border {
  border-radius: 12px !important;
  border: 1px solid #FFA726 !important;
}

.warning-button {
  margin-top: -30px;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 8px;
  width: 74px;
  background: rgba(237, 237, 237, 0.45) !important;
  border-radius: 8px !important;
  padding: 6px 8px !important;
}

.modern-name-field :deep(.v-field__append-inner .v-icon) {
  color: #872612 !important;
}

.modern-name-field :deep(.v-list .v-list-item--active .v-list-item-title) {
  color: #872612 !important;
  font-weight: 700;
}

.modern-name-field :deep(.v-list .v-list-item:hover .v-list-item-title) {
  color: #872612 !important;
}

.model-button {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 8px;
  width: 70px;
  background: rgba(237, 237, 237, 0.45) !important;
  border-radius: 8px !important;
  padding: 6px 8px !important;
}

.model-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.model-required {
  color: red;
  font-weight: 700;
  margin-left: 2px;
}

.model-select-row {
  row-gap: 12px;
}

.model-select-card {
  overflow: hidden;
}

.model-select-body {
  display: flex;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 16px;
  margin: 8px 0;
}

.model-select-field {
  flex: 1 1 260px;
  min-width: 0;
}

.model-name-field-fluid {
  border: 1px solid #c9c9c9;
  border-radius: 12px !important;
  background: #ffffff !important;
  height: 40px !important;
  width: 100% !important;
}

.model-name-field-fluid :deep(.v-field__append-inner .v-icon) {
  color: #872612 !important;
}

.model-name-field-fluid :deep(.v-list .v-list-item--active .v-list-item-title) {
  color: #872612 !important;
  font-weight: 700;
}

.model-name-field-fluid :deep(.v-list .v-list-item:hover .v-list-item-title) {
  color: #872612 !important;
}

.model-select-actions {
  flex: 0 0 auto;
}

.model-select-actions .model-button,
.model-select-actions .warning-button {
  margin-top: 0 !important;
}

@media (max-width: 599px) {
  .model-select-actions {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
}

.configuration-card-background {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(100deg, #FFF2F2 0%, #FFDED8 100%) !important;
  padding: 10px;
  border-bottom: 1px solid #c9c9c9;
}

.config-card {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 8px;
}

.header {
  font-size: 16px;
  font-weight: 600;
}

.parameter-card {
  border-radius: 12px !important;
}

.parameters-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #E7EBFF;
  border-bottom: 1px solid #c9c9c9;
}

.parameters-body {
  background: rgba(231, 235, 255, 0.25);
}

.log-modelA-header {
  display: flex;
  justify-content: space-between;
  align-items: center !important;
  width: 100%;
  background: #E7EBFF;
  padding: 10px;
  border-bottom: 1px solid #c9c9c9;
}

.message-user {
  background: rgba(195, 46, 14, 0.1);
  border-radius: 24px 0px 30px 24px;
  padding: 6px 12px;
}

.success-toast {
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(100deg, #1E7D3A, #135928);
  color: #ffffff;
  display: flex;
  align-items: center !important;
  font-size: 14px;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  z-index: 2100;
  width: 50%;
  max-width: 900px;
  min-width: 320px;
  justify-content: center !important;
  padding: 12px;
  border: 1px solid #ffffff;
  gap: 20px;
  margin-top: 80px;
  margin-left: 120px;
}

.card2 {
  border-radius: 10px !important;
  border: 1px solid #c9c9c9;
  padding: 16px;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
  display: flex;

  justify-content: space-between;
  align-items: stretch;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: stretch;
  height: 100%;
  padding: 15px;
}

:deep(.custom-textarea .v-input__control .v-input__slot .v-text-field__slot textarea) {
  margin-top: 12px !important;
}


::-webkit-scrollbar {
  height: 7px !important;
  width: 5px !important;
}

::-webkit-scrollbar-thumb {
  border-radius: 3px !important;
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translate(-50%, 20px);
  }

  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

@keyframes fade-out {
  from {
    opacity: 1;
    transform: translate(-50%, 0);
  }

  to {
    opacity: 0;
    transform: translate(-50%, 20px);
  }
}

/* Textarea container - matches Stream.vue's textarea-waveform-container */
.textarea-waveform-container {
  display: flex;
  padding: 8px 12px !important;
  min-width: 0;
  position: relative;
  background: #ffffff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
  border: 1px solid #c9c9c9 !important;
  border-radius: 25px !important;
  transition: all 0.3s ease !important;
}

.textarea-waveform-container:hover {
  border-color: #9CA3AF !important;
}

.textarea-waveform-container:focus-within {
  border: 1px solid #3859D0 !important;
  box-shadow: 0 4px 12px rgba(56, 89, 208, 0.15) !important;
}

.custom-chat-textarea,
.custom-chat-textarea-large {
  transition: all 0.3s ease !important;
}

.custom-chat-textarea :deep(.v-field),
.custom-chat-textarea-large :deep(.v-field) {
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
}

.chat-input-row {
  width: 100%;
}

.custom-chat-textarea :deep(.v-field__input) {
  padding: 8px 12px !important;
  font-size: 14px !important;
  line-height: 1.5 !important;
  color: #334155 !important;
  overflow-wrap: break-word !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  min-height: 30px !important;
}

.custom-chat-textarea-large :deep(.v-field__input) {
  padding: 8px 12px !important;
  font-size: 14px !important;
  line-height: 1.5 !important;
  color: #334155 !important;
  overflow-wrap: break-word !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  min-height: 30px !important;
}

.custom-chat-textarea :deep(.v-field__input::placeholder) {
  color: #94a3b8 !important;
}

.custom-chat-textarea :deep(.v-field__prepend-inner) {
  padding-left: 4px !important;
}

.custom-chat-textarea :deep(.v-field__append-inner) {
  padding-right: 4px !important;
}

.send-button {
  background: linear-gradient(135deg, var(--v-theme-primary) 0%, var(--v-theme-primary-darken-1) 100%) !important;
  box-shadow: 0 2px 8px rgba(var(--v-theme-primary-rgb), 0.3) !important;
  transition: all 0.2s ease !important;
}

.send-button:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(var(--v-theme-primary-rgb), 0.4) !important;
}

.send-image-button {
  width: 26px;
  height: 26px;
  background-size: cover;
  background-repeat: no-repeat;
  cursor: pointer;
}

.send-image-button.disabled {
  background-image: url('@/assets/Chat Service _ send icon_Disable.svg');
}

.send-image-button.active {
  background-image: url('@/assets/Chat Service _ send icon_Active.svg');
}

.send-image-button.active:hover,
.send-image-button.disabled:hover {
  background-image: url('@/assets/Chat Service _ send icon_Hover.svg') !important;
}

.stop-button {
  background: transparent !important;
  transition: all 0.2s ease !important;
}

.stop-button:hover {
  transform: translateY(-1px) !important;
}

.clear-button {
  transition: all 0.2s ease !important;
}

.clear-button:hover {
  background: rgba(113, 113, 122, 0.1) !important;
  transform: scale(1.05) !important;
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.7;
  }
}

.v-btn:disabled {
  animation: pulse 2s infinite;
  pointer-events: none !important;
  opacity: 0.6 !important;
  transition: none !important;
}

@media (max-width: 768px) {
  .custom-chat-textarea :deep(.v-field__input) {
    padding: 8px 10px !important;
    font-size: 14px !important;
  }

  .custom-chat-textarea-large :deep(.v-field__input) {
    padding: 8px 10px !important;
    font-size: 14px !important;
  }
}

@media (max-width: 599px) {

  .custom-chat-textarea :deep(.v-field__input::placeholder),
  .custom-chat-textarea-large :deep(.v-field__input::placeholder) {
    font-size: 12px !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
}

.v-theme--dark .custom-chat-textarea :deep(.v-field__input),
.v-theme--dark .custom-chat-textarea-large :deep(.v-field__input) {
  color: #e2e8f0 !important;
}

.v-theme--dark .custom-chat-textarea :deep(.v-field__input::placeholder),
.v-theme--dark .custom-chat-textarea-large :deep(.v-field__input::placeholder) {
  color: #64748b !important;
}

.custom-chat-textarea :deep(.v-counter),
.custom-chat-textarea-large :deep(.v-counter) {
  font-size: 11px !important;
  color: #64748b !important;
  margin-top: 4px !important;
}

.log-toggle-button {
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 12px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important;
  overflow: hidden !important;
}

.log-toggle-button:hover {
  transform: translateY(-1px) scale(1.05) !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15) !important;
  border-color: rgba(var(--v-theme-primary-rgb), 0.3) !important;
}


.log-toggle-button .v-icon {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.log-toggle-button:hover .v-icon {
  transform: scale(1.1) !important;
}

.modern-number-field {
  border: 1px solid #c9c9c9;
  border-radius: 12px !important;
  background: #ffffff !important;
}

.modern-label {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #171717 !important;
  letter-spacing: 0.5px !important;
  margin-bottom: 8px !important;
  display: block !important;
}

.model-input-control :deep(.v-field) {
  border: 1px solid #c9c9c9 !important;
  border-radius: 12px !important;
  min-height: 48px;
  box-shadow: none !important;
  background: #ffffff !important;
}

.warning-group {
  background: #FFFFFF !important;
  padding: 4px;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.16);
}

.model-input-control :deep(.v-input__details) {
  display: none;
}

.model-input-control :deep(.v-field__input) {
  padding-top: 13px;
}

.modern-config-field {
  transition: all 0.3s ease !important;
}

.modern-config-field :deep(.v-field) {
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%) !important;
  border: 2px solid rgba(148, 163, 184, 0.15) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04) !important;
}

.modern-config-field:hover :deep(.v-field) {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08) !important;
  transform: translateY(-1px) !important;
}

.modern-config-field :deep(.v-field__input) {
  padding: 12px 16px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #334155 !important;
}

.modern-config-field :deep(.v-label) {
  font-size: 12px !important;
  font-weight: 600 !important;
  color: #64748b !important;
}

.modern-config-field :deep(.v-field--focused .v-label) {
  color: var(--v-theme-primary) !important;
}

.modern-textarea {
  transition: all 0.3s ease !important;
}

.modern-textarea :deep(.v-field) {
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%) !important;
  border: 2px solid rgba(148, 163, 184, 0.15) !important;
  border-radius: 16px !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
}

.modern-textarea:hover :deep(.v-field) {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
  transform: translateY(-1px) !important;
}

.modern-textarea :deep(.v-field__input) {
  padding: 16px 20px !important;
  font-size: 14px !important;
  line-height: 1.6 !important;
  color: #334155 !important;
  font-family: 'SF Mono', 'Monaco', 'Menlo', 'Ubuntu Mono', monospace !important;
}

.modern-textarea :deep(.v-label) {
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #64748b !important;
  letter-spacing: 0.5px !important;
}

.modern-textarea :deep(.v-counter) {
  font-size: 11px !important;
  color: #94a3b8 !important;
  margin-top: 8px !important;
}

.modern-parameter-field {
  transition: all 0.3s ease !important;
}

.modern-parameter-field :deep(.v-field) {
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%) !important;
  border: 2px solid rgba(148, 163, 184, 0.12) !important;
  border-radius: 10px !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important;
}

.modern-parameter-field:hover :deep(.v-field) {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08) !important;
  transform: translateY(-0.5px) !important;
}

.modern-parameter-field :deep(.v-field__input) {
  padding: 10px 14px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #334155 !important;
  text-align: center !important;
}

.modern-parameter-field :deep(.v-field__input input) {
  text-align: center !important;
}

.modern-parameter-field :deep(.v-label) {
  font-size: 11px !important;
  font-weight: 600 !important;
  color: #64748b !important;
  letter-spacing: 0.3px !important;
}

.modern-parameter-field :deep(.v-field--disabled .v-label) {
  color: #94a3b8 !important;
}

.modern-parameter-field :deep(.v-field__prepend-inner) {
  padding-left: 6px !important;
  align-items: center !important;
}

.modern-parameter-field :deep(.v-field__append-inner) {
  padding-right: 6px !important;
  align-items: center !important;
}

.modern-parameter-field .v-tooltip,
.modern-config-field .v-tooltip,
.modern-textarea .v-tooltip {
  font-size: 12px !important;
  background: rgba(0, 0, 0, 0.85) !important;
  backdrop-filter: blur(4px) !important;
  border-radius: 8px !important;
  max-width: 250px !important;
}

@media (max-width: 768px) {

  .modern-config-field :deep(.v-field__input),
  .modern-parameter-field :deep(.v-field__input) {
    padding: 10px 12px !important;
    font-size: 16px !important;
  }

  .modern-textarea :deep(.v-field__input) {
    padding: 14px 16px !important;
    font-size: 16px !important;
  }
}

.v-btn:disabled:hover {
  transform: none !important;
  box-shadow: none !important;
  background-color: inherit !important;
  color: inherit !important;
}

.playground-char-counter {
  font-size: 12px;
  color: #71717A;
  margin-bottom: 1px;
}

.playground-char-counter--over {
  color: #dc2626;
  font-weight: 500;
}

.playground-char-limit-warning {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  width: 100%;
  padding-right: 16px;
  margin-top: 2px;
  font-size: 11px;
  line-height: 1.3;
  color: #dc2626;
}
</style>